// GENERATED by scratchpad/merge-i18n.mjs — do not hand-edit large blocks.
// Flat dot-namespaced keys, one entry per locale. Brand terms
// (Pakubuwono Social Club, padel) stay untranslated.

export const EN = {
  "account.changeEmail.currentLabel": "Current email",
  "account.changeEmail.newLabel": "New email address",
  "account.changeEmail.newPlaceholder": "you@example.com",
  "account.changeEmail.requestError":
    "Couldn't send a code to that email. Please try again.",
  "account.changeEmail.resendCode": "Resend code",
  "account.changeEmail.saveError":
    "Couldn't update your email. Please try again.",
  "account.changeEmail.saved": "Email updated",
  "account.changeEmail.sendCode": "Send code",
  "account.changeEmail.sending": "Sending…",
  "account.changeEmail.subtitle":
    "Enter your new email address. We'll send a code to verify it.",
  "account.changeEmail.title": "Change Email",
  "account.changeEmail.verify": "Verify & save",
  "account.changeEmail.verifyModeFieldLabel": "Your email address",
  "account.changeEmail.verifyModeSubtitle":
    "Confirm the email you added so we can reach you.",
  "account.changeEmail.verifyModeTitle": "Verify your email",
  "account.changeEmail.verifySubtitle": "Enter the 6-digit code we sent to",
  "account.changeEmail.verifyTitle": "Verify your new email",
  "account.changeEmail.verifying": "Verifying…",
  "account.changePassword.confirmLabel": "Confirm New Password",
  "account.changePassword.confirmPlaceholder": "Confirm new password",
  "account.changePassword.currentLabel": "Current Password",
  "account.changePassword.currentPlaceholder": "Enter current password",
  "account.changePassword.errorEnterCurrent": "Enter your current password.",
  "account.changePassword.errorGeneric":
    "Could not update password. Please try again.",
  "account.changePassword.errorMismatch": "New passwords do not match.",
  "account.changePassword.errorWeak":
    "New password must be 8+ characters with uppercase and lowercase letters, a number, and a symbol.",
  "account.changePassword.hidePassword": "Hide password",
  "account.changePassword.newLabel": "New Password",
  "account.changePassword.newPlaceholder": "Enter new password",
  "account.changePassword.requirements":
    "Your password must be at least 8 characters and include uppercase and lowercase letters, a number, and a symbol.",
  "account.changePassword.showPassword": "Show password",
  "account.changePassword.title": "Change Password",
  "account.changePassword.updateButton": "Update Password",
  "account.changePassword.updating": "Updating…",
  "account.changePhone.currentLabel": "Current phone",
  "account.changePhone.newLabel": "New phone number",
  "account.changePhone.requestError":
    "Couldn't send a code to that phone. Please try again.",
  "account.changePhone.resendCode": "Resend code",
  "account.changePhone.saveError":
    "Couldn't update your phone. Please try again.",
  "account.changePhone.saved": "Phone updated",
  "account.changePhone.sendCode": "Send code",
  "account.changePhone.sending": "Sending…",
  "account.changePhone.subtitle":
    "Enter your new phone number. We'll send a code to verify it.",
  "account.changePhone.title": "Change Phone",
  "account.changePhone.verify": "Verify & save",
  "account.changePhone.verifyModeFieldLabel": "Your phone number",
  "account.changePhone.verifyModeSubtitle":
    "Confirm the phone number you added so we can reach you.",
  "account.changePhone.verifyModeTitle": "Verify your phone",
  "account.changePhone.verifySubtitle": "Enter the 6-digit code we sent to",
  "account.changePhone.verifyTitle": "Verify your new phone",
  "account.changePhone.verifying": "Verifying…",
  "account.edit.contactSupport":
    "Contact support to change your email or phone.",
  "account.edit.dateOfBirth": "Date of Birth",
  "account.edit.emailAddress": "Email Address",
  "account.edit.fullName": "Full Name",
  "account.edit.gender": "Gender",
  "account.edit.genderFemale": "Female",
  "account.edit.genderMale": "Male",
  "account.edit.genderOther": "Rather not say / Others",
  "account.edit.genderPlaceholder": "Select gender",
  "account.edit.imageTooLarge": "Image must be 5MB or smaller.",
  "account.edit.phoneNumber": "Phone Number",
  "account.edit.photoAlt": "Selected profile photo",
  "account.edit.requiredFields":
    "Please fill in your name, date of birth, and gender.",
  "account.edit.save": "Save",
  "account.edit.saveError": "Couldn't save your profile. Please try again.",
  "account.edit.saved": "Profile updated",
  "account.edit.saving": "Saving…",
  "account.edit.tapToChange": "Tap to change",
  "account.edit.tapToChangePhoto": "Tap to change photo",
  "account.edit.title": "Edit Profile",
  "account.legal.legalInformation": "Legal Information",
  "account.notifications.daysAgo": "{n}d ago",
  "account.notifications.empty":
    "No notifications yet. We'll let you know when something happens.",
  "account.notifications.hoursAgo": "{n}h ago",
  "account.notifications.justNow": "just now",
  "account.notifications.markAllRead": "Mark all read",
  "account.notifications.minutesAgo": "{n}m ago",
  "account.notifications.title": "Notifications",
  "account.notifications.unread": "Unread",
  "account.profile.cancel": "Cancel",
  "account.profile.menuActivity": "Activity History",
  "account.profile.menuEditProfile": "Edit Profile",
  "account.profile.menuSettings": "Settings",
  "account.profile.signOut": "Sign Out",
  "account.profile.signOutConfirmBody":
    "You will be returned to the sign-in screen.",
  "account.profile.signOutConfirmTitle": "Sign out?",
  "account.profile.title": "Profile",
  "account.profile.viewFullCard": "View Full Card",
  "account.settings.changePassword": "Change Password",
  "account.settings.language": "Language",
  "account.settings.languageValue": "English",
  "account.settings.prefBookingReminders": "Booking Reminders",
  "account.settings.prefDisabled": "{label} disabled",
  "account.settings.prefEnabled": "{label} enabled",
  "account.settings.prefMembershipExpiry": "Membership Expiry",
  "account.settings.prefPromotions": "Promotions",
  "account.settings.privacyPolicy": "Privacy Policy",
  "account.settings.pushAddToHome": "Add to Home Screen first to enable push",
  "account.settings.pushAddToHomeHint": "Add to Home Screen to enable",
  "account.settings.pushDefaultHint": "Get alerts even when the app is closed",
  "account.settings.pushDisabled": "Push notifications disabled",
  "account.settings.pushEnabled": "Push notifications enabled",
  "account.settings.pushEnabledHint": "Enabled on this device",
  "account.settings.pushNotifications": "Push Notifications",
  "account.settings.pushPermissionDenied": "Permission denied",
  "account.settings.pushUnsupported":
    "Push notifications aren't supported on this browser",
  "account.settings.sectionAccount": "Account",
  "account.settings.sectionApp": "App",
  "account.settings.sectionLegal": "Legal",
  "account.settings.sectionNotifications": "Notifications",
  "account.settings.signOut": "Sign Out",
  "account.settings.termsOfService": "Terms of Service",
  "account.settings.title": "Settings",
  "account.settings.version": "Version",
  "activity.cancel.confirmCta": "Cancel booking",
  "activity.cancel.cta": "Cancel booking",
  "activity.cancel.errorBusy":
    "This booking is being updated right now. Try again in a moment.",
  "activity.cancel.errorGeneric":
    "We couldn't cancel this booking. Please try again.",
  "activity.cancel.errorNetwork":
    "Couldn't reach the club. Check your connection and try again.",
  "activity.cancel.errorReasonRequired":
    "Please tell us why you're cancelling.",
  "activity.cancel.errorReasonTooShort": "Please write at least 3 characters.",
  "activity.cancel.errorServer":
    "Something went wrong on our end. Please try again in a moment.",
  "activity.cancel.keepBooking": "Keep booking",
  "activity.cancel.noRefundNote":
    "This booking hasn't drawn on your hour balance, so there's nothing to return.",
  "activity.cancel.reasonLabel": "Reason for cancelling",
  "activity.cancel.reasonPlaceholder": "Tell us why (at least 3 characters)",
  "activity.cancel.refundNote":
    "{peak} peak and {regular} regular hours will be returned to your membership balance.",
  "activity.cancel.submitting": "Cancelling…",
  "activity.cancel.success": "Booking cancelled",
  "activity.cancel.title": "Cancel this booking?",
  "activity.detail.checkInHint":
    "Present your check-in code at reception to access the courts.",
  "activity.detail.amountDue": "Amount to pay",
  "activity.detail.amountPaid": "Amount paid",
  "activity.detail.cancelBlockedPaid":
    "Paid one-time bookings can't be cancelled in-app. Reschedule instead, or contact reception.",
  "activity.detail.cancelBlockedStatus":
    "This booking can no longer be cancelled.",
  "activity.detail.cancelCutoff":
    "Cancellation closes 24 hours before your session.",
  "activity.detail.cancelledAt": "Cancelled on",
  "activity.detail.cancelledByClub": "Cancelled by the club",
  "activity.detail.cancelledByYou": "Cancelled by you",
  "activity.detail.cancelledReason": "Reason",
  "activity.detail.date": "Date",
  "activity.detail.discount": "Discount",
  "activity.detail.location": "Pakubuwono Social Club",
  "activity.detail.minutesUnit": "min",
  "activity.detail.mixedLabel": "Mixed",
  "activity.detail.peakHours": "Peak",
  "activity.detail.regularHours": "Non-Peak",
  "activity.detail.hours": "Hours",
  "activity.detail.hoursUnit": "hr",
  "activity.detail.notFound": "Booking not found.",
  "activity.detail.payDeadline": "Time left to pay",
  "activity.detail.payError": "Couldn't open the payment page. Try again.",
  "activity.detail.payLinkExpired": "Payment window lapsed",
  "activity.detail.payNow": "Pay Now",
  "activity.detail.payNowLoading": "Opening payment…",
  "activity.detail.paymentRequired":
    "Complete payment at reception before you can check in.",
  "activity.detail.ref": "Ref #",
  "activity.detail.reschedule": "Reschedule",
  "activity.detail.rescheduleBlockedStatus":
    "This booking can no longer be rescheduled.",
  "activity.detail.rescheduleCutoff":
    "Reschedule closes 24 hours before your session.",
  "activity.detail.showCheckInCode": "Show check-in code",
  "activity.detail.status": "Status",
  "activity.detail.subtotal": "Subtotal",
  "activity.detail.total": "Total",
  "activity.detail.statusCompleted": "Completed",
  "activity.detail.bookAgain": "Book again",
  "activity.detail.statusCancelled": "Cancelled",
  "activity.detail.statusConfirming": "Confirming…",
  "activity.detail.statusMissed": "Missed — not checked in",
  "activity.detail.statusStarted": "In Progress",
  "activity.detail.statusUpcoming": "Upcoming",
  "activity.detail.statusWaitingPayment": "Waiting for Payment",
  "activity.detail.statusExpired": "Expired",
  "activity.detail.paymentMethod": "Payment Method",
  "activity.detail.paymentBalance": "Membership Hours",
  "activity.detail.paymentOnline": "Online Payment",
  "activity.detail.paymentReceptionist": "Pay at Reception",
  "activity.detail.time": "Time",
  "activity.detail.title": "Booking Detail",
  "activity.list.date": "Date",
  "activity.list.emptyPast": "No past activity yet.",
  "activity.list.emptyUpcoming":
    "No upcoming bookings. Book a court to get started.",
  "activity.list.minutesUnit": "min",
  "activity.list.pastDue": "Past due",
  "activity.list.tabPast": "Past",
  "activity.list.tabUpcoming": "Current",
  "activity.list.time": "Time",
  "activity.list.title": "My Activity",
  "activity.reschedule.cancel": "Cancel",
  "activity.reschedule.confirm": "Confirm Reschedule",
  "activity.reschedule.confirmCta": "Confirm",
  "activity.reschedule.confirmTitle": "Confirm new time",
  "activity.reschedule.court": "Court",
  "activity.reschedule.courtUnavailable":
    "Court unavailable. Please try again.",
  "activity.reschedule.error": "Couldn't reschedule. Please try again.",
  "activity.reschedule.hour": "hour",
  "activity.reschedule.hours": "hours",
  "activity.reschedule.invalid":
    "That time is no longer available. Pick another slot.",
  "activity.reschedule.mixMismatch":
    "Your booking mixes rates — pick {peak} peak and {regular} regular hour(s) to match it.",
  "activity.reschedule.moving": "Moving",
  "activity.reschedule.notFound": "Booking not found.",
  "activity.reschedule.pickNewTime": "Pick a new date and start time.",
  "activity.reschedule.submitting": "Rescheduling…",
  "activity.reschedule.success": "Booking rescheduled",
  "activity.reschedule.title": "Reschedule",
  "activity.reschedule.tooLate":
    "Reschedule closes 24 hours before your session.",
  "activity.reschedule.unchanged":
    "That's your current time. Pick a different date or start time.",
  "auth.forgotPassword.description":
    "Enter your email or phone number and we'll send a verification code to reset your password.",
  "auth.forgotPassword.failed": "Couldn't send a reset code. Please try again.",
  "auth.forgotPassword.phoneLabel": "Phone",
  "auth.forgotPassword.phonePlaceholder": "Enter your phone number",
  "auth.forgotPassword.sendCode": "Send Code",
  "auth.forgotPassword.title": "Reset password",
  "auth.form.channelEmail": "email",
  "auth.form.channelPhone": "phone",
  "auth.form.divider": "or",
  "auth.form.googleFailed": "Could not sign in with Google. Please try again.",
  "auth.form.emailLabel": "Email",
  "auth.form.emailPlaceholder": "Enter your email",
  "auth.form.hidePassword": "Hide password",
  "auth.form.passwordLabel": "Password",
  "auth.form.passwordPlaceholder": "Enter your password",
  "auth.form.emailInvalid": "Enter a valid email address.",
  "auth.form.phoneInvalid": "Enter a valid phone number.",
  "auth.form.phoneLabel": "Phone",
  "auth.form.pleaseWait": "Please wait…",
  "auth.form.showPassword": "Show password",
  "auth.otp.email": "Email",
  "auth.otp.number": "Number",
  "auth.otp.resendCode": "Resend Code",
  "auth.otp.resendFailed": "Could not resend the code.",
  "auth.otp.sentCode": "We've sent a 6-digit code to",
  "auth.otp.verify": "Verify",
  "auth.otp.verifyFailed": "Verification failed. Try again.",
  "auth.otp.verifyYour": "Verify Your",
  "auth.otp.verifying": "Verifying…",
  "auth.password.reqDigit": "A number",
  "auth.password.reqLength": "At least 8 characters",
  "auth.password.reqLower": "A lowercase letter",
  "auth.password.reqSymbol": "A symbol",
  "auth.password.reqUpper": "An uppercase letter",
  "auth.setPassword.confirmPasswordLabel": "Confirm Password",
  "auth.setPassword.confirmPasswordPlaceholder": "Re-enter new password",
  "auth.setPassword.continue": "Continue",
  "auth.setPassword.hidePassword": "Hide password",
  "auth.setPassword.minChars": "Must be at least 8 characters.",
  "auth.setPassword.mismatch": "Passwords don't match.",
  "auth.setPassword.newPasswordLabel": "New Password",
  "auth.setPassword.newPasswordPlaceholder": "Enter new password",
  "auth.setPassword.pleaseWait": "Please wait…",
  "auth.setPassword.setFailed": "Could not set your password. Try again.",
  "auth.setPassword.showPassword": "Show password",
  "auth.setPassword.subtitle": "Secure your account with a strong password.",
  "auth.setPassword.title": "Create Your Password",
  "auth.accountSuspended":
    "Your account has been suspended. Please contact support.",
  "auth.signIn.failed": "Incorrect phone number/email or password.",
  "auth.signIn.forgotPassword": "Forgot Password?",
  "auth.signIn.noAccount": "Don't have an account?",
  "auth.signIn.signUpLink": "Sign up",
  "auth.signIn.submit": "Sign In",
  "auth.signIn.tab": "Sign In",
  "auth.signUp.agreeAnd": "and",
  "auth.signUp.agreePrefix": "By continuing you agree to our",
  "auth.signUp.agreeSuffix": ".",
  "auth.signUp.failed": "Could not start sign up. Please try again.",
  "auth.signUp.haveAccount": "Already have an account?",
  "auth.signUp.privacyPolicy": "Privacy Policy",
  "auth.signUp.signInLink": "Sign in",
  "auth.signUp.submit": "Create Account",
  "auth.signUp.tab": "Sign Up",
  "auth.signUp.termsOfService": "Terms of Service",
  "auth.splash.taglineLine1": "The Ultimate Padel & Lifestyle",
  "auth.splash.taglineLine2": "Destination",
  "book.confirmed.awaitingPaymentSubtitle":
    "Pay at reception within 1 hour to confirm your booking.",
  "book.confirmed.awaitingPaymentTitle": "Court Reserved!",
  "book.confirmed.backToBooking": "Back to booking",
  "book.confirmed.backToHome": "Back to Home",
  "book.confirmed.checkInHint":
    "Present your check-in code at reception to access the courts.",
  "book.confirmed.completePaymentCta": "Continue to payment",
  "book.confirmed.completePaymentSubtitle":
    "Your court is held while you finish paying.",
  "book.confirmed.completePaymentTitle": "Complete your payment",
  "book.confirmed.confirmingSlotSubtitle":
    "We're confirming your slot. This only takes a moment.",
  "book.confirmed.courtLabel": "Court",
  "book.confirmed.dateLabel": "Date",
  "book.confirmed.failedSubtitle":
    "That slot was just taken. Please pick another time.",
  "book.confirmed.failedTitle": "Booking couldn't be confirmed",
  "book.confirmed.noBookingTitle": "No booking found.",
  "book.confirmed.payAtReception": "Pay at the receptionist",
  "book.confirmed.payAtReceptionHint":
    "Your check-in code unlocks once reception confirms your payment.",
  "book.confirmed.payFailedCta": "Open booking",
  "book.confirmed.payFailedSubtitle":
    "Your booking is saved. Open it to try the payment again.",
  "book.confirmed.payFailedTitle": "We couldn't start your payment",
  "book.confirmed.processingTitle": "Processing booking…",
  "book.confirmed.redirectingPaymentSubtitle":
    "You're being taken to our secure payment page.",
  "book.confirmed.redirectingPaymentTitle": "Opening payment…",
  "book.confirmed.refLabel": "Ref #",
  "book.confirmed.securingSubtitle": "Securing your court.",
  "book.confirmed.showCheckIn": "Show check-in code",
  "book.confirmed.successSubtitle":
    "Your padel court is secured. Prepare for a great session.",
  "book.confirmed.successTitle": "Booking Confirmed!",
  "book.confirmed.timeLabel": "Time",
  "book.confirmed.hoursDeducted": "Hours deducted",
  "book.confirmed.hoursLabel": "Hours",
  "book.confirmed.hoursSuffix": "hours",
  "book.confirmed.peakLabel": "peak",
  "book.confirmed.regularLabel": "non-peak",
  "book.confirmed.reminderNote":
    "We'll remind you 1 day and 1 hour before your session.",
  "book.confirmed.stillConfirming":
    "Still confirming — we'll let you know the moment it's done.",
  "book.confirmed.viewBookings": "View My Bookings",
  "book.detail.continueCta": "Continue to Review",
  "book.detail.courtRate": "Court Rate: {rate}/hr",
  "book.detail.dateLabel": "Date",
  "book.detail.durationLabel": "Duration",
  "book.detail.durationValuePlural": "{count} Hours",
  "book.detail.durationValueSingular": "{count} Hour",
  "book.detail.typeLabel": "Rate",
  "book.detail.typePeak": "Peak",
  "book.detail.typeHours": "Hours",
  "book.detail.typeRegular": "Non-Peak",
  "book.detail.typeMixed": "{peak} Peak · {regular} Non-Peak",
  "book.detail.hoursRequiredLabel": "Hours Required",
  "book.detail.peakHours": "Peak Hours",
  "book.detail.hours": "Hours",
  "book.detail.regularHours": "Non-Peak",
  "book.detail.timeLabel": "Time",
  "book.detail.title": "Slot Detail",
  "book.detail.totalValue": "Total value {value}",
  "book.detail.insufficientNote":
    "Not enough balance for this slot — you can pay at reception at the next step.",
  "book.detail.yourBalance": "Your Balance",
  "book.detail.hoursLeft": "{count}h left",
  "book.list.courtCountPlural": "{count} courts",
  "book.list.courtCountSingular": "{count} court",
  "book.list.headerTitle": "Bookings",
  "book.list.fromRate": "Start at {rate}/hr",
  "book.list.heading": "Book Padel",
  "book.list.subtitle": "Select a Court",
  "book.list.membershipExpired":
    "Your membership has expired. Remaining hours are forfeited — renew it to pay with hours again.",
  "book.review.balanceAfter": "Balance After",
  "book.review.cancellationNote":
    "Plans change. Reschedule or cancel free of charge up to 24 hours before your session — membership hours go straight back to your balance. Paid one-time bookings can be rescheduled but not cancelled in-app; contact reception.",
  "book.review.confirmCta": "Confirm Booking",
  "book.review.confirming": "Confirming…",
  "book.review.errorGeneric":
    "We couldn't complete your booking. Please try again.",
  "book.review.errorNetwork":
    "Couldn't reach the club. Check your connection and try again.",
  "book.review.errorServer":
    "Something went wrong on our end. Please try again in a moment.",
  "book.review.errorSlotTaken":
    "That time was just taken. Please pick another slot.",
  "book.review.slotTakenPickAgain": "Pick another slot",
  "book.review.insufficientBoth":
    "You don't have enough hours in your balance for this booking.",
  "book.review.insufficientPeak":
    "You don't have enough peak hours for this booking.",
  "book.review.insufficientRegular":
    "You don't have enough hours for this booking.",
  "book.review.switchToReception": "Pay at reception instead",
  "book.review.membershipExpired":
    "Your membership has expired, so paying with hours is unavailable. Pay online or at the receptionist.",
  "book.review.balancePastExpiry":
    "Your membership runs until {date}, so hours can't pay for this date. Pay at the receptionist, or renew your membership.",
  "book.review.currentBalance": "Current Balance",
  "book.review.dateLabel": "Date",
  "book.review.deductFromBalance": "Deduct from Balance",
  "book.review.durationLabel": "Duration",
  "book.review.durationValuePlural": "{count} Hours",
  "book.review.durationValueSingular": "{count} Hour",
  "book.review.typeLabel": "Rate",
  "book.review.typePeak": "Peak",
  "book.review.typeHours": "Hours",
  "book.review.typeRegular": "Non-Peak",
  "book.review.typeMixed": "{peak} Peak · {regular} Non-Peak",
  "book.review.guestsLabel": "Guests",
  "book.review.guestsValue": "Up to 4",
  "book.review.hoursToDeduct": "Hours to deduct",
  "book.review.hoursLeft": "{count}h left",
  "book.review.paymentMethod": "Payment Method",
  "book.review.payAtReceptionist": "Pay at Receptionist",
  "book.review.payAtReceptionistNote": "Settle your payment at the front desk.",
  "book.review.payOnline": "Pay Online",
  "book.review.payOnlineNote":
    "Pay securely with VA, card, or e-wallet via DOKU.",
  "book.review.payOnlineUnavailable": "Not Available Yet",
  "book.review.payOnlineUnavailableNote":
    "Online payment for bookings isn't available yet.",
  "book.gate.noMembershipTitle": "Booking isn't available yet",
  "book.gate.noMembershipBody":
    "Court booking is for members only. Buy a membership first to reserve a court.",
  "book.gate.expiredTitle": "Your membership has ended",
  "book.gate.expiredBody": "Renew your membership to book a court again.",
  "book.gate.inactiveTitle": "Your membership is inactive",
  "book.gate.inactiveBody":
    "Buy an hour package to reactivate your membership and book a court again.",
  "book.review.promoLabel": "Promo Code",
  "book.review.promoPlaceholder": "Enter a code",
  "book.review.promoApply": "Apply",
  "book.review.promoChecking": "Checking…",
  "book.review.promoInvalid": "That code isn't valid or has expired.",
  "book.review.promoCheckFailed": "Couldn't check that code. Please try again.",
  "book.review.subtotal": "Subtotal",
  "book.review.total": "Total",
  "book.review.peakHours": "Peak Hours",
  "book.review.hours": "Hours",
  "book.review.regularHours": "Non-Peak",
  "book.review.timeLabel": "Time",
  "book.review.title": "Review Booking",
  "book.slots.headerTitle": "Book Padel",
  "book.slots.heading": "Select Time",
  "book.slots.hourBadgePlural": "{count} Hours",
  "book.slots.hourBadgeSingular": "{count} Hour",
  "book.slots.peakHourBadgePlural": "{count} Peak Hours",
  "book.slots.peakHourBadgeSingular": "{count} Peak Hour",
  "book.slots.regularHourBadgePlural": "{count} Non-Peak Hours",
  "book.slots.regularHourBadgeSingular": "{count} Non-Peak Hour",
  "book.slots.checkingCta": "Checking availability…",
  "book.slots.recheckError": "Couldn't confirm availability. Please try again.",
  "book.slots.reviewCtaPlural": "Review Slots",
  "book.slots.reviewCtaSingular": "Review Slot",
  "book.slots.selectedSuffixPlural": "slots selected",
  "book.slots.selectedSuffixSingular": "slot selected",
  "book.slots.slotTakenWarning":
    "Some slots were just taken. Please pick again.",
  "book.slots.subtitle": "Choose your preferred slots across available courts.",
  "common.error.tooMany":
    "Too many attempts. Please wait a minute and try again.",
  "common.card.corporate": "Corporate",
  "common.card.member": "Member",
  "common.card.noMembership": "No Membership Available",
  "common.card.noQr": "No QR",
  "common.card.personal": "Personal",
  "common.card.qrAlt": "Member QR code",
  "common.card.scanAtFrontDesk": "Scan at front desk",
  "common.card.showFront": "Show card front",
  "common.card.showQr": "Show QR code",
  "common.card.showQrButton": "Show QR",
  "common.card.validThru": "Valid Thru",
  "common.court.booked": "Booked",
  "common.court.available": "Available",
  "common.court.unavailable": "Unavailable",
  "common.court.indoor": "Indoor",
  "common.court.legend.peak": "Peak",
  "common.court.legend.hours": "Hours",
  "common.court.legend.regular": "Non-Peak",
  "common.court.legend.selected": "Selected",
  "common.court.legend.unavailable": "Unavailable",
  "common.back.exitHint": "Press back again to exit",
  "common.court.time": "Time",
  "common.court.noMoreToday": "No more slots today — try another date.",
  "common.error.auth": "Your session expired. Please sign in again.",
  "common.error.generic":
    "Something went wrong loading this. Please try again.",
  "common.error.offline":
    "You're offline. Check your connection and try again.",
  "common.error.retry": "Try again",
  "common.error.server":
    "We can't reach the club right now. Please try again in a moment.",
  "common.goBack": "Go back",
  "common.nav.activity": "My Activity",
  "common.nav.book": "Book",
  "common.nav.home": "Home",
  "common.nav.notifications": "Notifications",
  "common.nav.profile": "Profile",
  "common.nav.unreadNotifications": "unread notifications",
  "common.otp.digit": "Digit",
  "home.card.bookingHistory.empty": "No bookings yet.",
  "home.card.bookingHistory.peakSuffix": "peak",
  "home.card.bookingHistory.hoursSuffix": "hours",
  "home.card.bookingHistory.regularSuffix": "non-peak",
  "home.card.bookingHistory.statusCancelled": "Cancelled",
  "home.card.bookingHistory.statusCompleted": "Completed",
  "home.card.bookingHistory.title": "Booking History",
  "home.card.bookingHistory.you": "You",
  "home.card.cardInformation": "Card Information",
  "home.card.footerNote":
    "Present this card or its number at the front desk for check-in and member-rate access across all Pakubuwono Social Club facilities.",
  "home.card.hoursLeft": "Hours left",
  "home.card.hoursRemaining": "Hours Remaining",
  "home.card.benefits.courtAccess.detail":
    "The Pro Court, Pink Court, Play Court",
  "home.card.benefits.courtAccess.title": "Court Access",
  "home.card.benefits.priorityBooking.detail": "Open one month ahead",
  "home.card.benefits.priorityBooking.title": "Priority Booking",
  "home.card.benefits.title": "Membership Benefits",
  "home.card.benefits.vipAccess.detail":
    "VIP Lounge & Private Rooms, Hot & Cold Plunge, Dedicated Parking, Complimentary Towel Service",
  "home.card.benefits.vipAccess.title": "VIP Access",
  "home.card.benefits.vipEvent.chip": "10% off",
  "home.card.benefits.vipEvent.chipLabel": "event registration",
  "home.card.benefits.vipEvent.detail": "Member invitation to our events",
  "home.card.benefits.vipEvent.title": "VIP Event",
  "home.card.benefits.vipPrivileges.detail":
    "A Private Concierge, Founding Membership Kit",
  "home.card.benefits.vipPrivileges.title": "VIP Privileges",
  "home.card.identityNote":
    "This is your membership identity. To check in for a court, use your check-in code.",
  "home.card.membershipStatus": "Membership status",
  "home.card.memberName": "Member Name",
  "home.card.memberSince": "Member Since",
  "home.card.membershipType": "Membership Type",
  "home.card.favoriteCourt": "Favorite Court",
  "home.card.favoriteCourtEmpty": "—",
  "home.card.hoursPlayed": "Hours Played",
  "home.card.peakHoursLeft": "Peak hours left",
  "home.card.playingStats": "Playing Stats",
  "home.card.registration": "Registration",
  "home.card.regularHoursLeft": "Non-Peak hours left",
  "home.card.sequenceNo": "Sequence No.",
  "home.card.sessions": "Sessions",
  "home.card.title": "Card Details",
  "home.checkin.noCode":
    "No active check-in code. Book a court for today to generate one.",
  "home.checkin.noUpcoming": "No upcoming bookings.",
  "home.checkin.qrAlt": "Check-in QR code",
  "home.checkin.qrWindow":
    "The QR code can be used 30 minutes before check-in.",
  "home.checkin.scanInstruction":
    "Scan this at the reception to check into your court.",
  "home.checkin.title": "Check-In Access",
  "home.checkin.today": "Today",
  "home.checkin.upcomingBooking": "Upcoming Booking",
  "home.checkin.liveCode": "Live code — refreshes automatically",
  "home.checkin.yourCode": "Check-in code",
  "home.dashboard.active": "Active",
  "home.dashboard.statusExpired": "Expired",
  "home.dashboard.statusInactive": "Inactive",
  "home.dashboard.bookAgain": "Book {court} again",
  "home.dashboard.inDays": "in {n}d",
  "home.dashboard.inHours": "in {n}h",
  "home.dashboard.inMinutes": "in {n} min",
  "home.dashboard.inProgress": "In progress",
  "home.dashboard.late": "Late — check in!",
  "home.dashboard.nextSession": "Next session",
  "home.dashboard.bookPadel": "Book Padel",
  "home.dashboard.checkIn": "Check In",
  "home.dashboard.comingSoon": "Coming Soon",
  "home.dashboard.findGame": "Find a Game",
  "home.dashboard.findGameDesc":
    "Find players at your skill level for a friendly match.",
  "home.dashboard.hoursLeft": "hrs left",
  "home.dashboard.lowBalanceBanner":
    "You're running low on hours — book a session to make the most of them.",
  "home.dashboard.lowHours": "Low",
  "home.dashboard.hours": "Hours",
  "home.dashboard.membershipHeading": "{type} Membership",
  "home.dashboard.noUpcoming":
    "No upcoming bookings. Book a court to get started.",
  "home.dashboard.orderFood": "Order Food",
  "home.dashboard.peakHours": "Peak Hours",
  "home.dashboard.pilates": "Pilates",
  "home.dashboard.quickActions": "Quick Actions",
  "home.dashboard.regularHours": "Non-Peak",
  "home.dashboard.soon": "Soon",
  "home.dashboard.title": "Home",
  "home.dashboard.today": "Today",
  "home.dashboard.tomorrow": "Tomorrow",
  "home.dashboard.typeCorporate": "Corporate",
  "home.dashboard.typePersonal": "Personal",
  "home.dashboard.upcoming": "Upcoming",
  "home.dashboard.validUntil": "Valid until {date}",
  "home.dashboard.viewAll": "View All",
  "home.dashboard.yourMembership": "Your Membership",
  "language.region.id": "Indonesia",
  "language.region.us": "United States",
  "language.select": "Select Language",
  "language.subtitle": "Choose your preferred language for the app interface.",
  "language.title": "Language",
  "onboarding.profileSetup.completeSetup": "Complete Setup",
  "onboarding.profileSetup.contactHelper":
    "We'll ask you to verify this later — no code needed now.",
  "onboarding.profileSetup.emailLabel": "Email Address",
  "onboarding.profileSetup.emailPlaceholder": "you@example.com",
  "onboarding.profileSetup.phoneLabel": "Phone Number",
  "onboarding.profileSetup.dobLabel": "Date of Birth",
  "onboarding.profileSetup.fullNameLabel": "Full Name",
  "onboarding.profileSetup.fullNamePlaceholder": "John Doe",
  "onboarding.profileSetup.genderFemale": "Female",
  "onboarding.profileSetup.genderLabel": "Gender",
  "onboarding.profileSetup.genderMale": "Male",
  "onboarding.profileSetup.genderOther": "Rather not say / Others",
  "onboarding.profileSetup.saveError":
    "Could not save your profile. Try again.",
  "onboarding.profileSetup.saving": "Saving…",
  "onboarding.profileSetup.subtitle": "Tell us about yourself.",
  "onboarding.profileSetup.title": "Welcome!",
  "onboarding.profileSetup.uploadPhotoLabel": "Upload profile photo",
  "onboarding.profileSetup.usernameLabel": "Username",
  "onboarding.profileSetup.usernamePlaceholder": "yourname",
  "onboarding.profileSetup.usernameHint":
    "3–30 characters: lowercase letters, numbers, _ and .",
  "onboarding.profileSetup.usernameAvailable": "Username is available",
  "onboarding.profileSetup.usernameTaken": "Username is already taken",
  "onboarding.profileSetup.usernameInvalid":
    "Only lowercase letters, numbers, _ and . — no leading, trailing, or double dots",
  "onboarding.tutorial.continue": "Continue",
  "onboarding.tutorial.getStarted": "Get Started",
  "onboarding.tutorial.regularLabel": "Non-Peak",
  "onboarding.tutorial.regularNote": "Applies daily",
  "onboarding.tutorial.skip": "Skip",
  "onboarding.tutorial.slide1Body":
    "Experience exclusive wellness, high-performance padel, and a community tailored to your luxury lifestyle.",
  "onboarding.tutorial.slide1ImageAlt": "Padel court at Pakubuwono Social Club",
  "onboarding.tutorial.slide1Welcome": "Welcome to",
  "onboarding.tutorial.slide2Body":
    "View your membership hours structure. Book times with ease.",
  "onboarding.tutorial.slide2ImageAlt": "Burgundy and gold clock",
  "onboarding.tutorial.slide2Title": "Operating Hours",
  "onboarding.tutorial.slide3Body":
    "Select your preferred club location, browse available time slots, and secure your court in seconds. Ready to serve?",
  "onboarding.tutorial.slide3ImageAlt": "Stylized padel court",
  "onboarding.tutorial.slide3Title": "Pick a Court, Pick a Time",
  "push.descEnable":
    "Enable push to get booking reminders even when the app is closed.",
  "push.descInstall":
    "Add this app to your Home Screen, then enable notifications for booking reminders.",
  "push.dismiss": "Dismiss",
  "push.enable": "Enable",
  "push.enabled": "Push notifications enabled",
  "push.enabling": "Enabling…",
  "push.permissionDenied": "Permission denied",
  "push.shareHint": "Share → Add to Home Screen",
  "push.title": "Stay in the loop",
  "pwa.addToHomeScreen": "Add to Home Screen",
  "pwa.dismiss": "Dismiss",
  "pwa.gotIt": "Got it",
  "pwa.install": "Install",
  "pwa.installSubtitle": "Faster access, full-screen, works offline.",
  "pwa.installTitle": "Install Pakubuwono",
  "pwa.iosIntro": "iPhone installs apps from the browser menu:",
  "pwa.step1After": "Share button",
  "completeData.continue": "Continue",
  "completeData.continuing": "Continuing…",
  "completeData.emailLabel": "Email address",
  "completeData.emailPlaceholder": "you@example.com",
  "completeData.phoneLabel": "Phone number",
  "completeData.requestError": "Couldn't send a code. Please try again.",
  "completeData.resendCode": "Resend code",
  "completeData.subtitleEmail":
    "Add an email address so we can send you receipts, bookings, and important account updates.",
  "completeData.subtitlePhone":
    "Add a phone number so we can text you booking confirmations and reminders.",
  "completeData.title": "Complete your account",
  "completeData.verify": "Verify",
  "completeData.verifyError": "Couldn't verify the code. Please try again.",
  "completeData.verifySubtitle": "Enter the 6-digit code we sent to",
  "completeData.verifyTitleEmail": "Verify your email",
  "completeData.verifyTitlePhone": "Verify your phone",
  "completeData.verifying": "Verifying…",
  "invitation.verifying": "Verifying your invitation…",
  "invitation.errorTitle": "Invitation link problem",
  "invitation.errorBody":
    "This invitation link is invalid or has expired. Please ask for a new one.",
  "invitation.goToSignIn": "Go to sign in",
  "pwa.step1Before": "Tap the",
  "pwa.step2Before": "Choose",
  "pwa.preview.title": "Install Pakubuwono Social Club",
  "pwa.preview.subtitle": "Get the full experience on your phone.",
  "pwa.preview.cta": "Install app",
  "pwa.preview.notNow": "Not now",
  "pwa.preview.featuresHeading": "What you'll get",
  "pwa.preview.feature1": "Quick access from your home screen",
  "pwa.preview.feature2": "Booking reminders and push notifications",
  "pwa.preview.feature3": "Full-screen experience with no browser bar",
  "pwa.preview.feature4": "Works offline for your check-in code",
  "pwa.ios.openInSafariTitle": "Open in Safari to install",
  "pwa.ios.openInSafariBody":
    "Other iOS browsers can't add apps to your home screen. Open this page in Safari and tap Install again.",
  "pwa.ios.openInSafariClose": "Got it",
  "pwa.ios.stepsHeading": "Add to Home Screen",
  "pwa.ios.stepsHint": "in Safari's toolbar",
  "pwa.homeCard.title": "Install the app",
  "pwa.homeCard.body":
    "Add Pakubuwono to your home screen for the best experience.",
  "pwa.update.title": "Update available",
  "pwa.update.body": "A new version of Pakubuwono is ready.",
  "pwa.update.reload": "Reload",
  "pwa.update.later": "Later",
  "verifyContact.nudge.phoneTitle": "Verify your phone number",
  "verifyContact.nudge.emailTitle": "Verify your email address",
  "verifyContact.nudge.body":
    "Confirm your contact so we can reach you about bookings and your membership.",
  "verifyContact.nudge.cta": "Verify",
  "verifyContact.nudge.dismiss": "Dismiss",
  "verifyContact.hint.phoneLabel": "Phone not verified",
  "verifyContact.hint.emailLabel": "Email not verified",
  "verifyContact.hint.action": "Verify",
  // --- Packages / buy hours ---
  "packages.list.title": "Buy Hours",
  "packages.list.history": "Purchase history",
  "packages.list.heroTitle": "Top up your court hours",
  "packages.list.heroBody":
    "Pick a package and keep playing. Every purchase extends your membership by the package's validity period.",
  "packages.list.empty": "No packages are available right now.",
  "packages.list.corporateTitle": "Managed by reception",
  "packages.list.corporateBody":
    "Corporate hours are topped up by reception. Contact the front desk to add hours to your plan.",
  "packages.card.peakChip": "{count}h peak",
  "packages.card.offPeakChip": "{count}h off-peak",
  "packages.card.hoursChip": "{count}h",
  "packages.card.validityChip": "{days}-day validity",
  "packages.detail.title": "Buy Hours",
  "packages.detail.paymentMethod": "Payment Method",
  "packages.detail.groupInstant": "Pay instantly",
  "packages.detail.groupTransfer": "Manual transfer",
  "packages.detail.noMethods": "No payment methods are available right now.",
  "packages.category.virtual_account": "Virtual Account",
  "packages.category.ewallet": "E-Wallet",
  "packages.category.qris": "QRIS",
  "packages.category.card": "Credit / Debit Card",
  "packages.category.minimarket": "Convenience Store",
  "packages.category.paylater": "PayLater",
  "packages.category.direct_debit": "Direct Debit",
  "packages.category.bank_digital": "Digital Bank",
  "packages.category.other": "Other",
  "packages.category.feeFrom": "Fee from {amount}",
  "packages.detail.validityNote":
    "Hours are credited once your payment is confirmed, and your membership is extended by this package's validity period.",
  "packages.detail.buyCta": "Choose a payment method",
  "packages.detail.buyCtaAmount": "Pay {amount}",
  "packages.detail.processing": "Processing…",
  "packages.detail.errorIneligible":
    "This package can't be purchased on your account.",
  "packages.detail.errorOffline":
    "You appear to be offline. Check your connection and try again.",
  "packages.detail.errorGeneric": "Something went wrong. Please try again.",
  "packages.method.feeAmount": "+ {amount} fee",
  "packages.method.feeGeneric": "+ processing fee",
  "packages.method.feeNone": "No extra fee",
  "packages.breakdown.price": "Package price",
  "packages.breakdown.fee": "Processing fee",
  "packages.breakdown.total": "Total",
  "packages.breakdown.calculating": "Calculating…",
  "packages.bank.title": "Transfer to",
  "packages.bank.bankName": "Bank",
  "packages.bank.accountNumber": "Account number",
  "packages.bank.accountHolder": "Account holder",
  "packages.bank.branch": "Branch",
  "packages.bank.copied": "Account number copied",
  "packages.proof.title": "Upload payment proof",
  "packages.proof.subtitle":
    "Attach a photo or screenshot of your transfer receipt.",
  "packages.proof.pick": "Tap to add a receipt",
  "packages.proof.change": "Change receipt",
  "packages.proof.previewAlt": "Payment proof",
  "packages.proof.noteLabel": "Note (optional)",
  "packages.proof.notePlaceholder": "Anything we should know?",
  "packages.proof.submit": "Submit for review",
  "packages.proof.uploading": "Uploading…",
  "packages.proof.uploaded": "Receipt uploaded",
  "packages.proof.uploadError":
    "Couldn't upload your receipt. Please try again.",
  "packages.proof.wrongType": "Please choose a JPG, PNG, or WEBP image.",
  "packages.proof.tooLarge":
    "That image is over 5MB. Please choose a smaller one.",
  "packages.status.awaitingPayment": "Awaiting payment",
  "packages.status.inReview": "In review",
  "packages.status.completed": "Completed",
  "packages.status.cancelled": "Cancelled",
  "packages.status.expired": "Expired",
  "packages.purchase.title": "Your Purchase",
  "packages.purchase.loadingTitle": "Loading your purchase…",
  "packages.purchase.loadingSubtitle": "This will just take a moment.",
  "packages.purchase.notFoundTitle": "Purchase not found",
  "packages.purchase.redirectingTitle": "Redirecting to payment…",
  "packages.purchase.redirectingSubtitle":
    "Taking you to the secure payment page.",
  "packages.purchase.completeTitle": "Complete your payment",
  "packages.purchase.completeSubtitle":
    "Your order is reserved. Finish paying to add your hours.",
  "packages.purchase.amountToPay": "Amount to pay",
  "packages.purchase.payDeadline": "Pay before",
  "packages.purchase.payLinkExpired": "Payment link expired",
  "packages.purchase.payNow": "Pay Now",
  "packages.purchase.payLoading": "Opening payment…",
  "packages.purchase.payError": "Couldn't open payment. Please try again.",
  "packages.purchase.receptionistTitle": "Pay at the front desk",
  "packages.purchase.receptionistSubtitle":
    "Show this purchase at the receptionist and pay there. Your hours are added once staff confirm the payment.",
  "packages.purchase.transferTitle": "Complete your transfer",
  "packages.purchase.transferSubtitle":
    "Transfer the exact amount, then upload your receipt below.",
  "packages.purchase.cancelReupload": "Cancel",
  "packages.purchase.awaitingTitle": "Awaiting verification",
  "packages.purchase.awaitingSubtitle":
    "An admin is reviewing your transfer. We'll add your hours once it's confirmed.",
  "packages.purchase.yourProof": "Your receipt",
  "packages.purchase.refreshStatus": "Refresh status",
  "packages.purchase.refreshing": "Refreshing…",
  "packages.purchase.reupload": "Upload a different receipt",
  "packages.purchase.cancelledTitle": "Payment cancelled",
  "packages.purchase.cancelledSubtitle":
    "This purchase was cancelled. You can start a new one anytime.",
  "packages.purchase.tryAgain": "Try again",
  "packages.purchase.expiredTitle": "Purchase expired",
  "packages.purchase.expiredSubtitle":
    "This purchase expired before payment. Please start over.",
  "packages.purchase.startOver": "Start over",
  "packages.purchase.successTitle": "Hours added!",
  "packages.purchase.successSubtitle":
    "Your hours are ready and your membership is active.",
  "packages.purchase.packageLabel": "Package",
  "packages.purchase.hoursCredited": "Hours Credited",
  "packages.purchase.membershipExtended": "Membership Extended",
  "packages.purchase.membershipExtendedValue": "+{days} days",
  "packages.purchase.creditedPeak": "{count}h peak",
  "packages.purchase.creditedOffPeak": "{count}h off-peak",
  "packages.purchase.amountPaid": "Amount Paid",
  "packages.purchase.viewHours": "View my hours",
  "packages.purchase.backHome": "Back to Home",
  "packages.history.title": "Purchase history",
  "packages.history.empty": "You haven't bought any hours yet.",
  // Entry points
  "home.dashboard.buyHours": "Buy Hours",
  "home.dashboard.topUpHours": "Top up",
  "home.card.buyMoreHours": "Buy more hours",
  "home.card.purchaseHistory": "Purchase history",
  "account.profile.menuPackages": "Buy Hours / Packages",
  "book.gate.buyHoursCta": "Buy hours",
  "book.gate.reactivateCta": "Buy hours to reactivate",
} as const

export type Key = keyof typeof EN

export const ID: Record<Key, string> = {
  "account.changeEmail.currentLabel": "Email saat ini",
  "account.changeEmail.newLabel": "Email baru",
  "account.changeEmail.newPlaceholder": "anda@contoh.com",
  "account.changeEmail.requestError":
    "Tidak dapat mengirim kode ke email tersebut. Silakan coba lagi.",
  "account.changeEmail.resendCode": "Kirim ulang kode",
  "account.changeEmail.saveError":
    "Tidak dapat memperbarui email Anda. Silakan coba lagi.",
  "account.changeEmail.saved": "Email diperbarui",
  "account.changeEmail.sendCode": "Kirim kode",
  "account.changeEmail.sending": "Mengirim…",
  "account.changeEmail.subtitle":
    "Masukkan alamat email baru Anda. Kami akan mengirim kode untuk memverifikasinya.",
  "account.changeEmail.title": "Ubah Email",
  "account.changeEmail.verify": "Verifikasi & simpan",
  "account.changeEmail.verifyModeFieldLabel": "Alamat email Anda",
  "account.changeEmail.verifyModeSubtitle":
    "Konfirmasi email yang Anda tambahkan agar kami dapat menghubungi Anda.",
  "account.changeEmail.verifyModeTitle": "Verifikasi Email",
  "account.changeEmail.verifySubtitle":
    "Masukkan kode 6 digit yang kami kirim ke",
  "account.changeEmail.verifyTitle": "Verifikasi email baru Anda",
  "account.changeEmail.verifying": "Memverifikasi…",
  "account.changePassword.confirmLabel": "Konfirmasi Kata Sandi Baru",
  "account.changePassword.confirmPlaceholder": "Konfirmasi kata sandi baru",
  "account.changePassword.currentLabel": "Kata Sandi Saat Ini",
  "account.changePassword.currentPlaceholder": "Masukkan kata sandi saat ini",
  "account.changePassword.errorEnterCurrent":
    "Masukkan kata sandi Anda saat ini.",
  "account.changePassword.errorGeneric":
    "Tidak dapat memperbarui kata sandi. Silakan coba lagi.",
  "account.changePassword.errorMismatch": "Kata sandi baru tidak cocok.",
  "account.changePassword.errorWeak":
    "Kata sandi baru harus minimal 8 karakter dengan huruf besar dan kecil, angka, dan simbol.",
  "account.changePassword.hidePassword": "Sembunyikan kata sandi",
  "account.changePassword.newLabel": "Kata Sandi Baru",
  "account.changePassword.newPlaceholder": "Masukkan kata sandi baru",
  "account.changePassword.requirements":
    "Kata sandi Anda harus minimal 8 karakter dan mencakup huruf besar dan kecil, angka, dan simbol.",
  "account.changePassword.showPassword": "Tampilkan kata sandi",
  "account.changePassword.title": "Ubah Kata Sandi",
  "account.changePassword.updateButton": "Perbarui Kata Sandi",
  "account.changePassword.updating": "Memperbarui…",
  "account.changePhone.currentLabel": "Telepon saat ini",
  "account.changePhone.newLabel": "Nomor telepon baru",
  "account.changePhone.requestError":
    "Tidak dapat mengirim kode ke nomor tersebut. Silakan coba lagi.",
  "account.changePhone.resendCode": "Kirim ulang kode",
  "account.changePhone.saveError":
    "Tidak dapat memperbarui nomor telepon Anda. Silakan coba lagi.",
  "account.changePhone.saved": "Nomor telepon diperbarui",
  "account.changePhone.sendCode": "Kirim kode",
  "account.changePhone.sending": "Mengirim…",
  "account.changePhone.subtitle":
    "Masukkan nomor telepon baru Anda. Kami akan mengirim kode untuk memverifikasinya.",
  "account.changePhone.title": "Ubah Telepon",
  "account.changePhone.verify": "Verifikasi & simpan",
  "account.changePhone.verifyModeFieldLabel": "Nomor telepon Anda",
  "account.changePhone.verifyModeSubtitle":
    "Konfirmasi nomor telepon yang Anda tambahkan agar kami dapat menghubungi Anda.",
  "account.changePhone.verifyModeTitle": "Verifikasi Ponsel",
  "account.changePhone.verifySubtitle":
    "Masukkan kode 6 digit yang kami kirim ke",
  "account.changePhone.verifyTitle": "Verifikasi nomor telepon baru",
  "account.changePhone.verifying": "Memverifikasi…",
  "account.edit.contactSupport":
    "Hubungi dukungan untuk mengubah email atau telepon Anda.",
  "account.edit.dateOfBirth": "Tanggal Lahir",
  "account.edit.emailAddress": "Alamat Email",
  "account.edit.fullName": "Nama Lengkap",
  "account.edit.gender": "Jenis Kelamin",
  "account.edit.genderFemale": "Perempuan",
  "account.edit.genderMale": "Laki-laki",
  "account.edit.genderOther": "Tidak ingin menyebutkan / Lainnya",
  "account.edit.genderPlaceholder": "Pilih jenis kelamin",
  "account.edit.imageTooLarge": "Gambar harus 5MB atau lebih kecil.",
  "account.edit.phoneNumber": "Nomor Telepon",
  "account.edit.photoAlt": "Foto profil yang dipilih",
  "account.edit.requiredFields":
    "Mohon isi nama, tanggal lahir, dan jenis kelamin Anda.",
  "account.edit.save": "Simpan",
  "account.edit.saveError":
    "Tidak dapat menyimpan profil Anda. Silakan coba lagi.",
  "account.edit.saved": "Profil diperbarui",
  "account.edit.saving": "Menyimpan…",
  "account.edit.tapToChange": "Ketuk untuk mengubah",
  "account.edit.tapToChangePhoto": "Ketuk untuk mengganti foto",
  "account.edit.title": "Edit Profil",
  "account.legal.legalInformation": "Informasi Hukum",
  "account.notifications.daysAgo": "{n}h lalu",
  "account.notifications.empty":
    "Belum ada notifikasi. Kami akan memberi tahu Anda saat ada sesuatu.",
  "account.notifications.hoursAgo": "{n}j lalu",
  "account.notifications.justNow": "baru saja",
  "account.notifications.markAllRead": "Tandai semua dibaca",
  "account.notifications.minutesAgo": "{n}mnt lalu",
  "account.notifications.title": "Notifikasi",
  "account.notifications.unread": "Belum dibaca",
  "account.profile.cancel": "Batal",
  "account.profile.menuActivity": "Riwayat Aktivitas",
  "account.profile.menuEditProfile": "Edit Profil",
  "account.profile.menuSettings": "Pengaturan",
  "account.profile.signOut": "Keluar",
  "account.profile.signOutConfirmBody":
    "Anda akan dikembalikan ke layar masuk.",
  "account.profile.signOutConfirmTitle": "Keluar?",
  "account.profile.title": "Profil",
  "account.profile.viewFullCard": "Lihat Kartu Lengkap",
  "account.settings.changePassword": "Ubah Kata Sandi",
  "account.settings.language": "Bahasa",
  "account.settings.languageValue": "Inggris",
  "account.settings.prefBookingReminders": "Pengingat Pemesanan",
  "account.settings.prefDisabled": "{label} dinonaktifkan",
  "account.settings.prefEnabled": "{label} diaktifkan",
  "account.settings.prefMembershipExpiry": "Masa Berlaku Keanggotaan",
  "account.settings.prefPromotions": "Promosi",
  "account.settings.privacyPolicy": "Kebijakan Privasi",
  "account.settings.pushAddToHome":
    "Tambahkan ke Layar Utama dulu untuk mengaktifkan push",
  "account.settings.pushAddToHomeHint":
    "Tambahkan ke Layar Utama untuk mengaktifkan",
  "account.settings.pushDefaultHint":
    "Terima pemberitahuan meski aplikasi ditutup",
  "account.settings.pushDisabled": "Notifikasi push dinonaktifkan",
  "account.settings.pushEnabled": "Notifikasi push diaktifkan",
  "account.settings.pushEnabledHint": "Aktif di perangkat ini",
  "account.settings.pushNotifications": "Notifikasi Push",
  "account.settings.pushPermissionDenied": "Izin ditolak",
  "account.settings.pushUnsupported":
    "Notifikasi push tidak didukung di peramban ini",
  "account.settings.sectionAccount": "Akun",
  "account.settings.sectionApp": "Aplikasi",
  "account.settings.sectionLegal": "Hukum",
  "account.settings.sectionNotifications": "Notifikasi",
  "account.settings.signOut": "Keluar",
  "account.settings.termsOfService": "Ketentuan Layanan",
  "account.settings.title": "Pengaturan",
  "account.settings.version": "Versi",
  "activity.cancel.confirmCta": "Batalkan pemesanan",
  "activity.cancel.cta": "Batalkan pemesanan",
  "activity.cancel.errorBusy":
    "Pemesanan ini sedang diproses. Silakan coba lagi sebentar.",
  "activity.cancel.errorGeneric":
    "Kami tidak dapat membatalkan pemesanan ini. Silakan coba lagi.",
  "activity.cancel.errorNetwork":
    "Tidak dapat terhubung ke klub. Periksa koneksi Anda dan coba lagi.",
  "activity.cancel.errorReasonRequired":
    "Silakan beri tahu alasan pembatalan Anda.",
  "activity.cancel.errorReasonTooShort": "Tulis minimal 3 karakter.",
  "activity.cancel.errorServer":
    "Terjadi kesalahan di sisi kami. Silakan coba lagi sebentar.",
  "activity.cancel.keepBooking": "Pertahankan pemesanan",
  "activity.cancel.noRefundNote":
    "Pemesanan ini belum memotong saldo jam Anda, jadi tidak ada yang dikembalikan.",
  "activity.cancel.reasonLabel": "Alasan pembatalan",
  "activity.cancel.reasonPlaceholder":
    "Beri tahu kami alasannya (minimal 3 karakter)",
  "activity.cancel.refundNote":
    "{peak} jam sibuk dan {regular} jam reguler akan dikembalikan ke saldo keanggotaan Anda.",
  "activity.cancel.submitting": "Membatalkan…",
  "activity.cancel.success": "Pemesanan dibatalkan",
  "activity.cancel.title": "Batalkan pemesanan ini?",
  "activity.detail.checkInHint":
    "Tunjukkan kode check-in Anda di resepsionis untuk mengakses lapangan.",
  "activity.detail.amountDue": "Jumlah yang harus dibayar",
  "activity.detail.amountPaid": "Jumlah yang dibayar",
  "activity.detail.cancelBlockedPaid":
    "Pemesanan sekali pakai yang sudah dibayar tidak dapat dibatalkan di aplikasi. Silakan jadwalkan ulang atau hubungi resepsionis.",
  "activity.detail.cancelBlockedStatus":
    "Pemesanan ini tidak dapat dibatalkan lagi.",
  "activity.detail.cancelCutoff":
    "Pembatalan ditutup 24 jam sebelum sesi Anda.",
  "activity.detail.cancelledAt": "Dibatalkan pada",
  "activity.detail.cancelledByClub": "Dibatalkan oleh klub",
  "activity.detail.cancelledByYou": "Dibatalkan oleh Anda",
  "activity.detail.cancelledReason": "Alasan",
  "activity.detail.date": "Tanggal",
  "activity.detail.discount": "Potongan",
  "activity.detail.location": "Pakubuwono Social Club",
  "activity.detail.minutesUnit": "mnt",
  "activity.detail.mixedLabel": "Campuran",
  "activity.detail.peakHours": "Sibuk",
  "activity.detail.regularHours": "Non-Sibuk",
  "activity.detail.hours": "Jam",
  "activity.detail.hoursUnit": "jam",
  "activity.detail.notFound": "Pemesanan tidak ditemukan.",
  "activity.detail.payDeadline": "Sisa waktu pembayaran",
  "activity.detail.payError":
    "Tidak dapat membuka halaman pembayaran. Coba lagi.",
  "activity.detail.payLinkExpired": "Batas waktu pembayaran berakhir",
  "activity.detail.payNow": "Bayar Sekarang",
  "activity.detail.payNowLoading": "Membuka pembayaran…",
  "activity.detail.paymentRequired":
    "Selesaikan pembayaran di resepsionis sebelum dapat check-in.",
  "activity.detail.ref": "No. Ref",
  "activity.detail.reschedule": "Jadwalkan Ulang",
  "activity.detail.rescheduleBlockedStatus":
    "Pemesanan ini tidak dapat dijadwalkan ulang lagi.",
  "activity.detail.rescheduleCutoff":
    "Penjadwalan ulang ditutup 24 jam sebelum sesi Anda.",
  "activity.detail.showCheckInCode": "Tampilkan kode check-in",
  "activity.detail.status": "Status",
  "activity.detail.subtotal": "Subtotal",
  "activity.detail.total": "Total",
  "activity.detail.statusCompleted": "Selesai",
  "activity.detail.bookAgain": "Pesan lagi",
  "activity.detail.statusCancelled": "Dibatalkan",
  "activity.detail.statusConfirming": "Mengonfirmasi…",
  "activity.detail.statusMissed": "Terlewat — belum check-in",
  "activity.detail.statusStarted": "Sedang Berlangsung",
  "activity.detail.statusUpcoming": "Mendatang",
  "activity.detail.statusWaitingPayment": "Menunggu Pembayaran",
  "activity.detail.statusExpired": "Kedaluwarsa",
  "activity.detail.paymentMethod": "Metode Pembayaran",
  "activity.detail.paymentBalance": "Jam Keanggotaan",
  "activity.detail.paymentOnline": "Pembayaran Online",
  "activity.detail.paymentReceptionist": "Bayar di Resepsionis",
  "activity.detail.time": "Waktu",
  "activity.detail.title": "Detail Pemesanan",
  "activity.list.date": "Tanggal",
  "activity.list.emptyPast": "Belum ada aktivitas lampau.",
  "activity.list.emptyUpcoming":
    "Belum ada pemesanan mendatang. Pesan lapangan untuk memulai.",
  "activity.list.minutesUnit": "mnt",
  "activity.list.pastDue": "Terlewat",
  "activity.list.tabPast": "Lampau",
  "activity.list.tabUpcoming": "Saat Ini",
  "activity.list.time": "Waktu",
  "activity.list.title": "Aktivitas Saya",
  "activity.reschedule.cancel": "Batal",
  "activity.reschedule.confirm": "Konfirmasi Jadwal Ulang",
  "activity.reschedule.confirmCta": "Konfirmasi",
  "activity.reschedule.confirmTitle": "Konfirmasi waktu baru",
  "activity.reschedule.court": "Lapangan",
  "activity.reschedule.courtUnavailable":
    "Lapangan tidak tersedia. Silakan coba lagi.",
  "activity.reschedule.error": "Gagal menjadwalkan ulang. Silakan coba lagi.",
  "activity.reschedule.hour": "jam",
  "activity.reschedule.hours": "jam",
  "activity.reschedule.invalid":
    "Waktu tersebut sudah tidak tersedia. Pilih slot lain.",
  "activity.reschedule.mixMismatch":
    "Pemesanan Anda menggabungkan tarif — pilih {peak} jam sibuk dan {regular} jam non-sibuk agar sesuai.",
  "activity.reschedule.moving": "Memindahkan",
  "activity.reschedule.notFound": "Pemesanan tidak ditemukan.",
  "activity.reschedule.pickNewTime": "Pilih tanggal dan waktu mulai baru.",
  "activity.reschedule.submitting": "Menjadwalkan ulang…",
  "activity.reschedule.success": "Pemesanan berhasil dijadwalkan ulang",
  "activity.reschedule.title": "Jadwalkan Ulang",
  "activity.reschedule.tooLate":
    "Penjadwalan ulang ditutup 24 jam sebelum sesi Anda.",
  "activity.reschedule.unchanged":
    "Itu waktu Anda saat ini. Pilih tanggal atau waktu mulai lain.",
  "auth.forgotPassword.description":
    "Masukkan email atau nomor telepon Anda dan kami akan mengirim kode verifikasi untuk mengatur ulang kata sandi.",
  "auth.forgotPassword.failed":
    "Tidak dapat mengirim kode reset. Silakan coba lagi.",
  "auth.forgotPassword.phoneLabel": "Telepon",
  "auth.forgotPassword.phonePlaceholder": "Masukkan nomor telepon Anda",
  "auth.forgotPassword.sendCode": "Kirim Kode",
  "auth.forgotPassword.title": "Atur ulang kata sandi",
  "auth.form.channelEmail": "email",
  "auth.form.channelPhone": "telepon",
  "auth.form.divider": "atau",
  "auth.form.googleFailed":
    "Tidak dapat masuk dengan Google. Silakan coba lagi.",
  "auth.form.emailLabel": "Email",
  "auth.form.emailPlaceholder": "Masukkan email Anda",
  "auth.form.hidePassword": "Sembunyikan kata sandi",
  "auth.form.passwordLabel": "Kata Sandi",
  "auth.form.passwordPlaceholder": "Masukkan kata sandi Anda",
  "auth.form.emailInvalid": "Masukkan alamat email yang valid.",
  "auth.form.phoneInvalid": "Masukkan nomor telepon yang valid.",
  "auth.form.phoneLabel": "Telepon",
  "auth.form.pleaseWait": "Mohon tunggu…",
  "auth.form.showPassword": "Tampilkan kata sandi",
  "auth.otp.email": "Email",
  "auth.otp.number": "Nomor",
  "auth.otp.resendCode": "Kirim Ulang Kode",
  "auth.otp.resendFailed": "Tidak dapat mengirim ulang kode.",
  "auth.otp.sentCode": "Kami telah mengirim kode 6 digit ke",
  "auth.otp.verify": "Verifikasi",
  "auth.otp.verifyFailed": "Verifikasi gagal. Coba lagi.",
  "auth.otp.verifyYour": "Verifikasi",
  "auth.otp.verifying": "Memverifikasi…",
  "auth.password.reqDigit": "Satu angka",
  "auth.password.reqLength": "Minimal 8 karakter",
  "auth.password.reqLower": "Satu huruf kecil",
  "auth.password.reqSymbol": "Satu simbol",
  "auth.password.reqUpper": "Satu huruf besar",
  "auth.setPassword.confirmPasswordLabel": "Konfirmasi Kata Sandi",
  "auth.setPassword.confirmPasswordPlaceholder":
    "Masukkan ulang kata sandi baru",
  "auth.setPassword.continue": "Lanjutkan",
  "auth.setPassword.hidePassword": "Sembunyikan kata sandi",
  "auth.setPassword.minChars": "Minimal 8 karakter.",
  "auth.setPassword.mismatch": "Kata sandi tidak cocok.",
  "auth.setPassword.newPasswordLabel": "Kata Sandi Baru",
  "auth.setPassword.newPasswordPlaceholder": "Masukkan kata sandi baru",
  "auth.setPassword.pleaseWait": "Mohon tunggu…",
  "auth.setPassword.setFailed":
    "Tidak dapat menyetel kata sandi Anda. Coba lagi.",
  "auth.setPassword.showPassword": "Tampilkan kata sandi",
  "auth.setPassword.subtitle": "Amankan akun Anda dengan kata sandi yang kuat.",
  "auth.setPassword.title": "Buat Kata Sandi Anda",
  "auth.accountSuspended":
    "Akun Anda telah ditangguhkan. Silakan hubungi dukungan.",
  "auth.signIn.failed": "Nomor HP/email atau password salah.",
  "auth.signIn.forgotPassword": "Lupa kata sandi?",
  "auth.signIn.noAccount": "Belum punya akun?",
  "auth.signIn.signUpLink": "Daftar",
  "auth.signIn.submit": "Masuk",
  "auth.signIn.tab": "Masuk",
  "auth.signUp.agreeAnd": "dan",
  "auth.signUp.agreePrefix": "Dengan melanjutkan, Anda menyetujui",
  "auth.signUp.agreeSuffix": " kami.",
  "auth.signUp.failed": "Tidak dapat memulai pendaftaran. Silakan coba lagi.",
  "auth.signUp.haveAccount": "Sudah punya akun?",
  "auth.signUp.privacyPolicy": "Kebijakan Privasi",
  "auth.signUp.signInLink": "Masuk",
  "auth.signUp.submit": "Buat Akun",
  "auth.signUp.tab": "Daftar",
  "auth.signUp.termsOfService": "Syarat Layanan",
  "auth.splash.taglineLine1": "Destinasi Padel & Gaya Hidup",
  "auth.splash.taglineLine2": "Terbaik",
  "book.confirmed.awaitingPaymentSubtitle":
    "Bayar di resepsionis dalam 1 jam untuk mengonfirmasi pemesanan Anda.",
  "book.confirmed.awaitingPaymentTitle": "Lapangan Direservasi!",
  "book.confirmed.backToBooking": "Kembali ke pemesanan",
  "book.confirmed.backToHome": "Kembali ke Beranda",
  "book.confirmed.checkInHint":
    "Tunjukkan kode check-in Anda di resepsionis untuk mengakses lapangan.",
  "book.confirmed.completePaymentCta": "Lanjutkan ke pembayaran",
  "book.confirmed.completePaymentSubtitle":
    "Lapangan Anda ditahan selagi Anda menyelesaikan pembayaran.",
  "book.confirmed.completePaymentTitle": "Selesaikan pembayaran Anda",
  "book.confirmed.confirmingSlotSubtitle":
    "Kami sedang mengonfirmasi slot Anda. Ini hanya sebentar.",
  "book.confirmed.courtLabel": "Lapangan",
  "book.confirmed.dateLabel": "Tanggal",
  "book.confirmed.failedSubtitle":
    "Slot itu baru saja terisi. Silakan pilih waktu lain.",
  "book.confirmed.failedTitle": "Pemesanan tidak dapat dikonfirmasi",
  "book.confirmed.noBookingTitle": "Pemesanan tidak ditemukan.",
  "book.confirmed.payAtReception": "Bayar di resepsionis",
  "book.confirmed.payAtReceptionHint":
    "Kode check-in Anda akan terbuka setelah resepsionis mengonfirmasi pembayaran Anda.",
  "book.confirmed.payFailedCta": "Buka pemesanan",
  "book.confirmed.payFailedSubtitle":
    "Pemesanan Anda tersimpan. Buka untuk mencoba pembayaran lagi.",
  "book.confirmed.payFailedTitle": "Pembayaran tidak dapat dimulai",
  "book.confirmed.processingTitle": "Memproses pemesanan…",
  "book.confirmed.redirectingPaymentSubtitle":
    "Anda sedang diarahkan ke halaman pembayaran yang aman.",
  "book.confirmed.redirectingPaymentTitle": "Membuka pembayaran…",
  "book.confirmed.refLabel": "No. Ref",
  "book.confirmed.securingSubtitle": "Mengamankan lapangan Anda.",
  "book.confirmed.showCheckIn": "Tampilkan kode check-in",
  "book.confirmed.successSubtitle":
    "Lapangan padel Anda telah diamankan. Bersiaplah untuk sesi yang seru.",
  "book.confirmed.successTitle": "Pemesanan Dikonfirmasi!",
  "book.confirmed.timeLabel": "Waktu",
  "book.confirmed.hoursDeducted": "Jam dipotong",
  "book.confirmed.hoursLabel": "Jam",
  "book.confirmed.hoursSuffix": "jam",
  "book.confirmed.peakLabel": "sibuk",
  "book.confirmed.regularLabel": "non-sibuk",
  "book.confirmed.reminderNote":
    "Kami akan mengingatkan Anda 1 hari dan 1 jam sebelum sesi Anda.",
  "book.confirmed.stillConfirming":
    "Masih mengonfirmasi — kami akan memberi tahu Anda begitu selesai.",
  "book.confirmed.viewBookings": "Lihat Pemesanan Saya",
  "book.detail.continueCta": "Lanjut ke Tinjauan",
  "book.detail.courtRate": "Tarif Lapangan: {rate}/jam",
  "book.detail.dateLabel": "Tanggal",
  "book.detail.durationLabel": "Durasi",
  "book.detail.durationValuePlural": "{count} Jam",
  "book.detail.durationValueSingular": "{count} Jam",
  "book.detail.typeLabel": "Tarif",
  "book.detail.typePeak": "Sibuk",
  "book.detail.typeHours": "Jam",
  "book.detail.typeRegular": "Non-Sibuk",
  "book.detail.typeMixed": "{peak} Sibuk · {regular} Non-Sibuk",
  "book.detail.hoursRequiredLabel": "Jam Dibutuhkan",
  "book.detail.peakHours": "Jam Sibuk",
  "book.detail.hours": "Jam",
  "book.detail.regularHours": "Non-Sibuk",
  "book.detail.timeLabel": "Waktu",
  "book.detail.title": "Detail Slot",
  "book.detail.totalValue": "Total nilai {value}",
  "book.detail.insufficientNote":
    "Saldo tidak cukup untuk slot ini — Anda dapat membayar di resepsionis pada langkah berikutnya.",
  "book.detail.yourBalance": "Saldo Anda",
  "book.detail.hoursLeft": "sisa {count}j",
  "book.list.courtCountPlural": "{count} lapangan",
  "book.list.courtCountSingular": "{count} lapangan",
  "book.list.headerTitle": "Pemesanan",
  "book.list.fromRate": "Mulai dari {rate}/jam",
  "book.list.heading": "Pesan Padel",
  "book.list.subtitle": "Pilih Lapangan",
  "book.list.membershipExpired":
    "Masa berlaku membership Anda sudah berakhir. Sisa jam hangus — perpanjang dulu untuk bisa bayar pakai saldo jam.",
  "book.review.balanceAfter": "Saldo Setelahnya",
  "book.review.cancellationNote":
    "Rencana bisa berubah. Jadwalkan ulang atau batalkan tanpa biaya hingga 24 jam sebelum sesi Anda — jam keanggotaan langsung kembali ke saldo. Pemesanan sekali pakai yang sudah dibayar dapat dijadwalkan ulang tetapi tidak dapat dibatalkan di aplikasi; silakan hubungi resepsionis.",
  "book.review.confirmCta": "Konfirmasi Pemesanan",
  "book.review.confirming": "Mengonfirmasi…",
  "book.review.errorGeneric":
    "Kami tidak dapat menyelesaikan pemesanan Anda. Silakan coba lagi.",
  "book.review.errorNetwork":
    "Tidak dapat terhubung ke klub. Periksa koneksi Anda dan coba lagi.",
  "book.review.errorServer":
    "Terjadi kesalahan di sisi kami. Silakan coba lagi sebentar.",
  "book.review.errorSlotTaken":
    "Waktu itu baru saja terisi. Silakan pilih slot lain.",
  "book.review.slotTakenPickAgain": "Pilih slot lain",
  "book.review.insufficientBoth":
    "Saldo jam Anda tidak cukup untuk pemesanan ini.",
  "book.review.insufficientPeak":
    "Jam sibuk Anda tidak cukup untuk pemesanan ini.",
  "book.review.insufficientRegular":
    "Jam Anda tidak cukup untuk pemesanan ini.",
  "book.review.switchToReception": "Bayar di resepsionis saja",
  "book.review.membershipExpired":
    "Masa berlaku membership Anda sudah berakhir, jadi bayar pakai saldo jam tidak tersedia. Silakan bayar online atau di resepsionis.",
  "book.review.balancePastExpiry":
    "Membership Anda berlaku sampai {date}, jadi saldo jam tidak bisa dipakai untuk tanggal ini. Silakan bayar di resepsionis, atau perpanjang membership Anda.",
  "book.review.currentBalance": "Saldo Saat Ini",
  "book.review.dateLabel": "Tanggal",
  "book.review.deductFromBalance": "Potong dari Saldo",
  "book.review.durationLabel": "Durasi",
  "book.review.durationValuePlural": "{count} Jam",
  "book.review.durationValueSingular": "{count} Jam",
  "book.review.typeLabel": "Tarif",
  "book.review.typePeak": "Sibuk",
  "book.review.typeHours": "Jam",
  "book.review.typeRegular": "Non-Sibuk",
  "book.review.typeMixed": "{peak} Sibuk · {regular} Non-Sibuk",
  "book.review.guestsLabel": "Tamu",
  "book.review.guestsValue": "Hingga 4",
  "book.review.hoursToDeduct": "Jam yang dipotong",
  "book.review.hoursLeft": "sisa {count}j",
  "book.review.paymentMethod": "Metode Pembayaran",
  "book.review.payAtReceptionist": "Bayar di Resepsionis",
  "book.review.payAtReceptionistNote":
    "Lakukan pembayaran di meja resepsionis.",
  "book.review.payOnline": "Bayar Online",
  "book.review.payOnlineNote":
    "Bayar dengan aman via VA, kartu, atau e-wallet melalui DOKU.",
  "book.review.payOnlineUnavailable": "Belum Tersedia",
  "book.review.payOnlineUnavailableNote":
    "Pembayaran online untuk booking belum tersedia.",
  "book.gate.noMembershipTitle": "Booking belum tersedia",
  "book.gate.noMembershipBody":
    "Booking lapangan hanya untuk member. Silakan beli membership terlebih dahulu untuk memesan lapangan.",
  "book.gate.expiredTitle": "Membership Anda sudah berakhir",
  "book.gate.expiredBody":
    "Perpanjang membership Anda untuk dapat booking lapangan kembali.",
  "book.gate.inactiveTitle": "Membership Anda sedang tidak aktif",
  "book.gate.inactiveBody":
    "Beli paket jam untuk mengaktifkan kembali membership Anda dan booking lapangan lagi.",
  "book.review.promoLabel": "Kode Promo",
  "book.review.promoPlaceholder": "Masukkan kode",
  "book.review.promoApply": "Terapkan",
  "book.review.promoChecking": "Memeriksa…",
  "book.review.promoInvalid": "Kode tidak valid atau sudah kedaluwarsa.",
  "book.review.promoCheckFailed":
    "Tidak dapat memeriksa kode. Silakan coba lagi.",
  "book.review.subtotal": "Subtotal",
  "book.review.total": "Total",
  "book.review.peakHours": "Jam Sibuk",
  "book.review.hours": "Jam",
  "book.review.regularHours": "Non-Sibuk",
  "book.review.timeLabel": "Waktu",
  "book.review.title": "Tinjau Pemesanan",
  "book.slots.headerTitle": "Pesan Padel",
  "book.slots.heading": "Pilih Waktu",
  "book.slots.hourBadgePlural": "{count} Jam",
  "book.slots.hourBadgeSingular": "{count} Jam",
  "book.slots.peakHourBadgePlural": "{count} Jam Sibuk",
  "book.slots.peakHourBadgeSingular": "{count} Jam Sibuk",
  "book.slots.regularHourBadgePlural": "{count} Jam Non-Sibuk",
  "book.slots.regularHourBadgeSingular": "{count} Jam Non-Sibuk",
  "book.slots.checkingCta": "Memeriksa ketersediaan…",
  "book.slots.recheckError": "Tidak dapat memastikan ketersediaan. Coba lagi.",
  "book.slots.reviewCtaPlural": "Tinjau Slot",
  "book.slots.reviewCtaSingular": "Tinjau Slot",
  "book.slots.selectedSuffixPlural": "slot dipilih",
  "book.slots.selectedSuffixSingular": "slot dipilih",
  "book.slots.slotTakenWarning":
    "Beberapa slot baru saja terisi. Silakan pilih lagi.",
  "book.slots.subtitle":
    "Pilih slot yang Anda inginkan dari lapangan yang tersedia.",
  "common.error.tooMany":
    "Terlalu banyak percobaan. Mohon tunggu satu menit lalu coba lagi.",
  "common.card.corporate": "Korporat",
  "common.card.member": "Anggota",
  "common.card.noMembership": "Tidak ada keanggotaan",
  "common.card.noQr": "Tanpa QR",
  "common.card.personal": "Personal",
  "common.card.qrAlt": "Kode QR anggota",
  "common.card.scanAtFrontDesk": "Pindai di meja depan",
  "common.card.showFront": "Tampilkan depan kartu",
  "common.card.showQr": "Tampilkan kode QR",
  "common.card.showQrButton": "Tampilkan QR",
  "common.card.validThru": "Berlaku Hingga",
  "common.court.booked": "Terisi",
  "common.court.available": "Tersedia",
  "common.court.unavailable": "Tidak Tersedia",
  "common.court.indoor": "Indoor",
  "common.court.legend.peak": "Sibuk",
  "common.court.legend.hours": "Jam",
  "common.court.legend.regular": "Non-Sibuk",
  "common.court.legend.selected": "Dipilih",
  "common.court.legend.unavailable": "Tidak Tersedia",
  "common.back.exitHint": "Tekan sekali lagi untuk keluar",
  "common.court.time": "Waktu",
  "common.court.noMoreToday":
    "Tidak ada slot lagi hari ini — coba tanggal lain.",
  "common.error.auth": "Sesi Anda berakhir. Silakan masuk kembali.",
  "common.error.generic": "Terjadi kesalahan saat memuat. Silakan coba lagi.",
  "common.error.offline":
    "Anda sedang offline. Periksa koneksi Anda dan coba lagi.",
  "common.error.retry": "Coba lagi",
  "common.error.server":
    "Kami tidak dapat menghubungi klub saat ini. Silakan coba lagi sebentar.",
  "common.goBack": "Kembali",
  "common.nav.activity": "Aktivitas Saya",
  "common.nav.book": "Pesan",
  "common.nav.home": "Beranda",
  "common.nav.notifications": "Notifikasi",
  "common.nav.profile": "Profil",
  "common.nav.unreadNotifications": "notifikasi belum dibaca",
  "common.otp.digit": "Digit",
  "home.card.bookingHistory.empty": "Belum ada booking.",
  "home.card.bookingHistory.peakSuffix": "sibuk",
  "home.card.bookingHistory.hoursSuffix": "jam",
  "home.card.bookingHistory.regularSuffix": "non-sibuk",
  "home.card.bookingHistory.statusCancelled": "Dibatalkan",
  "home.card.bookingHistory.statusCompleted": "Selesai",
  "home.card.bookingHistory.title": "Riwayat Booking",
  "home.card.bookingHistory.you": "Anda",
  "home.card.cardInformation": "Informasi Kartu",
  "home.card.footerNote":
    "Tunjukkan kartu ini atau nomornya di meja depan untuk check-in dan akses tarif anggota di seluruh fasilitas Pakubuwono Social Club.",
  "home.card.hoursLeft": "Sisa jam",
  "home.card.hoursRemaining": "Sisa Jam",
  "home.card.benefits.courtAccess.detail":
    "The Pro Court, Pink Court, Play Court",
  "home.card.benefits.courtAccess.title": "Akses Lapangan",
  "home.card.benefits.priorityBooking.detail": "Buka satu bulan lebih awal",
  "home.card.benefits.priorityBooking.title": "Pemesanan Prioritas",
  "home.card.benefits.title": "Manfaat Keanggotaan",
  "home.card.benefits.vipAccess.detail":
    "VIP Lounge & Ruang Privat, Hot & Cold Plunge, Parkir Khusus, Layanan Handuk Gratis",
  "home.card.benefits.vipAccess.title": "VIP Access",
  "home.card.benefits.vipEvent.chip": "Diskon 10%",
  "home.card.benefits.vipEvent.chipLabel": "registrasi acara",
  "home.card.benefits.vipEvent.detail": "Undangan anggota ke acara kami",
  "home.card.benefits.vipEvent.title": "VIP Event",
  "home.card.benefits.vipPrivileges.detail":
    "Concierge Pribadi, Founding Membership Kit",
  "home.card.benefits.vipPrivileges.title": "VIP Privileges",
  "home.card.identityNote":
    "Ini adalah identitas keanggotaan Anda. Untuk check in lapangan, gunakan kode check-in Anda.",
  "home.card.membershipStatus": "Status keanggotaan",
  "home.card.memberName": "Nama Anggota",
  "home.card.memberSince": "Anggota Sejak",
  "home.card.membershipType": "Tipe Keanggotaan",
  "home.card.favoriteCourt": "Lapangan Favorit",
  "home.card.favoriteCourtEmpty": "—",
  "home.card.hoursPlayed": "Jam Bermain",
  "home.card.peakHoursLeft": "Sisa jam sibuk",
  "home.card.playingStats": "Statistik Bermain",
  "home.card.registration": "Registrasi",
  "home.card.regularHoursLeft": "Sisa jam non-sibuk",
  "home.card.sequenceNo": "No. Urut",
  "home.card.sessions": "Sesi",
  "home.card.title": "Detail Kartu",
  "home.checkin.noCode":
    "Tidak ada kode check-in aktif. Pesan lapangan untuk hari ini untuk membuatnya.",
  "home.checkin.noUpcoming": "Tidak ada pemesanan mendatang.",
  "home.checkin.qrAlt": "Kode QR check-in",
  "home.checkin.qrWindow": "Kode QR dapat digunakan 30 menit sebelum check-in.",
  "home.checkin.scanInstruction":
    "Pindai ini di resepsionis untuk check-in ke lapangan Anda.",
  "home.checkin.title": "Akses Check-In",
  "home.checkin.today": "Hari Ini",
  "home.checkin.upcomingBooking": "Pemesanan Mendatang",
  "home.checkin.liveCode": "Kode langsung — diperbarui otomatis",
  "home.checkin.yourCode": "Kode check-in",
  "home.dashboard.active": "Aktif",
  "home.dashboard.statusExpired": "Kedaluwarsa",
  "home.dashboard.statusInactive": "Nonaktif",
  "home.dashboard.bookAgain": "Pesan {court} lagi",
  "home.dashboard.inDays": "{n} hari lagi",
  "home.dashboard.inHours": "{n} jam lagi",
  "home.dashboard.inMinutes": "{n} menit lagi",
  "home.dashboard.inProgress": "Sedang berlangsung",
  "home.dashboard.late": "Telat nih!",
  "home.dashboard.nextSession": "Sesi berikutnya",
  "home.dashboard.bookPadel": "Pesan Padel",
  "home.dashboard.checkIn": "Check In",
  "home.dashboard.comingSoon": "Segera Hadir",
  "home.dashboard.findGame": "Cari Permainan",
  "home.dashboard.findGameDesc":
    "Temukan pemain selevel Anda untuk pertandingan santai.",
  "home.dashboard.hoursLeft": "jam tersisa",
  "home.dashboard.lowBalanceBanner":
    "Jam Anda hampir habis — pesan sesi untuk memanfaatkannya sebaik mungkin.",
  "home.dashboard.lowHours": "Hampir Habis",
  "home.dashboard.hours": "Jam",
  "home.dashboard.membershipHeading": "Keanggotaan {type}",
  "home.dashboard.noUpcoming":
    "Belum ada pemesanan. Pesan lapangan untuk memulai.",
  "home.dashboard.orderFood": "Pesan Makanan",
  "home.dashboard.peakHours": "Jam Sibuk",
  "home.dashboard.pilates": "Pilates",
  "home.dashboard.quickActions": "Aksi Cepat",
  "home.dashboard.regularHours": "Non-Sibuk",
  "home.dashboard.soon": "Segera",
  "home.dashboard.title": "Beranda",
  "home.dashboard.today": "Hari Ini",
  "home.dashboard.tomorrow": "Besok",
  "home.dashboard.typeCorporate": "Korporat",
  "home.dashboard.typePersonal": "Personal",
  "home.dashboard.upcoming": "Mendatang",
  "home.dashboard.validUntil": "Berlaku hingga {date}",
  "home.dashboard.viewAll": "Lihat Semua",
  "home.dashboard.yourMembership": "Keanggotaan Anda",
  "language.region.id": "Indonesia",
  "language.region.us": "Amerika Serikat",
  "language.select": "Pilih Bahasa",
  "language.subtitle":
    "Pilih bahasa yang Anda inginkan untuk antarmuka aplikasi.",
  "language.title": "Bahasa",
  "onboarding.profileSetup.completeSetup": "Selesaikan Pendaftaran",
  "onboarding.profileSetup.contactHelper":
    "Kami akan meminta Anda memverifikasinya nanti — tanpa kode sekarang.",
  "onboarding.profileSetup.emailLabel": "Alamat Email",
  "onboarding.profileSetup.emailPlaceholder": "anda@contoh.com",
  "onboarding.profileSetup.phoneLabel": "Nomor Telepon",
  "onboarding.profileSetup.dobLabel": "Tanggal Lahir",
  "onboarding.profileSetup.fullNameLabel": "Nama Lengkap",
  "onboarding.profileSetup.fullNamePlaceholder": "Budi Santoso",
  "onboarding.profileSetup.genderFemale": "Wanita",
  "onboarding.profileSetup.genderLabel": "Jenis Kelamin",
  "onboarding.profileSetup.genderMale": "Pria",
  "onboarding.profileSetup.genderOther": "Tidak ingin menyebutkan / Lainnya",
  "onboarding.profileSetup.saveError":
    "Tidak dapat menyimpan profil Anda. Coba lagi.",
  "onboarding.profileSetup.saving": "Menyimpan…",
  "onboarding.profileSetup.subtitle": "Ceritakan tentang Anda.",
  "onboarding.profileSetup.title": "Selamat datang!",
  "onboarding.profileSetup.uploadPhotoLabel": "Unggah foto profil",
  "onboarding.profileSetup.usernameLabel": "Nama Pengguna",
  "onboarding.profileSetup.usernamePlaceholder": "namaanda",
  "onboarding.profileSetup.usernameHint":
    "3–30 karakter: huruf kecil, angka, _ dan .",
  "onboarding.profileSetup.usernameAvailable": "Nama pengguna tersedia",
  "onboarding.profileSetup.usernameTaken": "Nama pengguna sudah dipakai",
  "onboarding.profileSetup.usernameInvalid":
    "Hanya huruf kecil, angka, _ dan . — tanpa titik di awal, akhir, atau ganda",
  "onboarding.tutorial.continue": "Lanjutkan",
  "onboarding.tutorial.getStarted": "Mulai",
  "onboarding.tutorial.regularLabel": "Non-Sibuk",
  "onboarding.tutorial.regularNote": "Berlaku tiap hari",
  "onboarding.tutorial.skip": "Lewati",
  "onboarding.tutorial.slide1Body":
    "Nikmati wellness eksklusif, padel berperforma tinggi, dan komunitas yang sesuai dengan gaya hidup mewah Anda.",
  "onboarding.tutorial.slide1ImageAlt":
    "Lapangan padel di Pakubuwono Social Club",
  "onboarding.tutorial.slide1Welcome": "Selamat datang di",
  "onboarding.tutorial.slide2Body":
    "Lihat struktur jam keanggotaan Anda. Pesan waktu dengan mudah.",
  "onboarding.tutorial.slide2ImageAlt": "Jam berwarna marun dan emas",
  "onboarding.tutorial.slide2Title": "Jam Operasional",
  "onboarding.tutorial.slide3Body":
    "Pilih lokasi klub favorit Anda, jelajahi slot waktu yang tersedia, dan amankan lapangan dalam hitungan detik. Siap bermain?",
  "onboarding.tutorial.slide3ImageAlt": "Ilustrasi lapangan padel",
  "onboarding.tutorial.slide3Title": "Pilih Lapangan, Pilih Waktu",
  "push.descEnable":
    "Aktifkan push untuk menerima pengingat booking walau aplikasi tertutup.",
  "push.descInstall":
    "Tambahkan aplikasi ini ke Layar Utama Anda, lalu aktifkan notifikasi untuk pengingat booking.",
  "push.dismiss": "Tutup",
  "push.enable": "Aktifkan",
  "push.enabled": "Notifikasi push diaktifkan",
  "push.enabling": "Mengaktifkan…",
  "push.permissionDenied": "Izin ditolak",
  "push.shareHint": "Bagikan → Tambah ke Layar Utama",
  "push.title": "Tetap terhubung",
  "pwa.addToHomeScreen": "Tambah ke Layar Utama",
  "pwa.dismiss": "Tutup",
  "pwa.gotIt": "Mengerti",
  "pwa.install": "Pasang",
  "pwa.installSubtitle": "Akses lebih cepat, layar penuh, bisa offline.",
  "pwa.installTitle": "Pasang Pakubuwono",
  "pwa.iosIntro": "iPhone memasang aplikasi dari menu browser:",
  "pwa.step1After": "tombol Share",
  "pwa.step1Before": "Ketuk",
  "pwa.step2Before": "Pilih",
  "completeData.continue": "Lanjutkan",
  "completeData.continuing": "Memproses…",
  "completeData.emailLabel": "Alamat email",
  "completeData.emailPlaceholder": "anda@contoh.com",
  "completeData.phoneLabel": "Nomor telepon",
  "completeData.requestError": "Tidak dapat mengirim kode. Silakan coba lagi.",
  "completeData.resendCode": "Kirim ulang kode",
  "completeData.subtitleEmail":
    "Tambahkan alamat email agar kami dapat mengirim Anda struk, booking, dan pembaruan akun penting.",
  "completeData.subtitlePhone":
    "Tambahkan nomor telepon agar kami dapat mengirim konfirmasi booking dan pengingat lewat pesan.",
  "completeData.title": "Lengkapi akun Anda",
  "completeData.verify": "Verifikasi",
  "completeData.verifyError":
    "Tidak dapat memverifikasi kode. Silakan coba lagi.",
  "completeData.verifySubtitle": "Masukkan kode 6 digit yang kami kirim ke",
  "completeData.verifyTitleEmail": "Verifikasi email Anda",
  "completeData.verifyTitlePhone": "Verifikasi nomor telepon Anda",
  "completeData.verifying": "Memverifikasi…",
  "invitation.verifying": "Memverifikasi undangan Anda…",
  "invitation.errorTitle": "Masalah tautan undangan",
  "invitation.errorBody":
    "Tautan undangan ini tidak valid atau telah kedaluwarsa. Silakan minta yang baru.",
  "invitation.goToSignIn": "Ke halaman masuk",
  "pwa.preview.title": "Pasang Pakubuwono Social Club",
  "pwa.preview.subtitle": "Dapatkan pengalaman terbaik di ponsel Anda.",
  "pwa.preview.cta": "Pasang aplikasi",
  "pwa.preview.notNow": "Nanti saja",
  "pwa.preview.featuresHeading": "Yang Anda dapatkan",
  "pwa.preview.feature1": "Akses cepat dari layar utama Anda",
  "pwa.preview.feature2": "Pengingat booking dan notifikasi push",
  "pwa.preview.feature3": "Tampilan layar penuh tanpa bilah peramban",
  "pwa.preview.feature4": "Bisa diakses offline untuk kode check-in Anda",
  "pwa.ios.openInSafariTitle": "Buka di Safari untuk memasang",
  "pwa.ios.openInSafariBody":
    "Peramban iOS lain tidak dapat menambahkan aplikasi ke layar utama. Buka halaman ini di Safari dan ketuk Pasang lagi.",
  "pwa.ios.openInSafariClose": "Mengerti",
  "pwa.ios.stepsHeading": "Tambah ke Layar Utama",
  "pwa.ios.stepsHint": "di toolbar Safari",
  "pwa.homeCard.title": "Pasang aplikasi",
  "pwa.homeCard.body":
    "Tambahkan Pakubuwono ke layar utama Anda untuk pengalaman terbaik.",
  "pwa.update.title": "Pembaruan tersedia",
  "pwa.update.body": "Versi baru Pakubuwono siap dipasang.",
  "pwa.update.reload": "Muat ulang",
  "pwa.update.later": "Nanti",
  "verifyContact.nudge.phoneTitle": "Verifikasi nomor telepon Anda",
  "verifyContact.nudge.emailTitle": "Verifikasi alamat email Anda",
  "verifyContact.nudge.body":
    "Konfirmasi kontak Anda agar kami dapat menghubungi Anda tentang pemesanan dan keanggotaan.",
  "verifyContact.nudge.cta": "Verifikasi",
  "verifyContact.nudge.dismiss": "Tutup",
  "verifyContact.hint.phoneLabel": "Telepon belum diverifikasi",
  "verifyContact.hint.emailLabel": "Email belum diverifikasi",
  "verifyContact.hint.action": "Verifikasi",
  // --- Paket / beli jam ---
  "packages.list.title": "Beli Jam",
  "packages.list.history": "Riwayat pembelian",
  "packages.list.heroTitle": "Isi ulang jam bermain Anda",
  "packages.list.heroBody":
    "Pilih paket dan terus bermain. Setiap pembelian memperpanjang keanggotaan Anda sesuai masa berlaku paket.",
  "packages.list.empty": "Belum ada paket yang tersedia saat ini.",
  "packages.list.corporateTitle": "Dikelola oleh resepsionis",
  "packages.list.corporateBody":
    "Jam korporat diisi ulang oleh resepsionis. Hubungi meja depan untuk menambah jam pada paket Anda.",
  "packages.card.peakChip": "{count} jam peak",
  "packages.card.offPeakChip": "{count} jam off-peak",
  "packages.card.hoursChip": "{count} jam",
  "packages.card.validityChip": "Berlaku {days} hari",
  "packages.detail.title": "Beli Jam",
  "packages.detail.paymentMethod": "Metode Pembayaran",
  "packages.detail.groupInstant": "Bayar instan",
  "packages.detail.groupTransfer": "Transfer manual",
  "packages.detail.noMethods": "Belum ada metode pembayaran yang tersedia.",
  "packages.category.virtual_account": "Virtual Account",
  "packages.category.ewallet": "Dompet Digital",
  "packages.category.qris": "QRIS",
  "packages.category.card": "Kartu Kredit / Debit",
  "packages.category.minimarket": "Minimarket",
  "packages.category.paylater": "PayLater",
  "packages.category.direct_debit": "Direct Debit",
  "packages.category.bank_digital": "Bank Digital",
  "packages.category.other": "Lainnya",
  "packages.category.feeFrom": "Biaya mulai {amount}",
  "packages.detail.validityNote":
    "Jam ditambahkan setelah pembayaran Anda dikonfirmasi, dan keanggotaan Anda diperpanjang sesuai masa berlaku paket ini.",
  "packages.detail.buyCta": "Pilih metode pembayaran",
  "packages.detail.buyCtaAmount": "Bayar {amount}",
  "packages.detail.processing": "Memproses…",
  "packages.detail.errorIneligible":
    "Paket ini tidak dapat dibeli dengan akun Anda.",
  "packages.detail.errorOffline":
    "Anda tampaknya sedang offline. Periksa koneksi Anda dan coba lagi.",
  "packages.detail.errorGeneric": "Terjadi kesalahan. Silakan coba lagi.",
  "packages.method.feeAmount": "+ biaya {amount}",
  "packages.method.feeGeneric": "+ biaya proses",
  "packages.method.feeNone": "Tanpa biaya tambahan",
  "packages.breakdown.price": "Harga paket",
  "packages.breakdown.fee": "Biaya proses",
  "packages.breakdown.total": "Total",
  "packages.breakdown.calculating": "Menghitung…",
  "packages.bank.title": "Transfer ke",
  "packages.bank.bankName": "Bank",
  "packages.bank.accountNumber": "Nomor rekening",
  "packages.bank.accountHolder": "Atas nama",
  "packages.bank.branch": "Cabang",
  "packages.bank.copied": "Nomor rekening disalin",
  "packages.proof.title": "Unggah bukti pembayaran",
  "packages.proof.subtitle":
    "Lampirkan foto atau tangkapan layar bukti transfer Anda.",
  "packages.proof.pick": "Ketuk untuk menambah bukti",
  "packages.proof.change": "Ganti bukti",
  "packages.proof.previewAlt": "Bukti pembayaran",
  "packages.proof.noteLabel": "Catatan (opsional)",
  "packages.proof.notePlaceholder": "Ada yang perlu kami ketahui?",
  "packages.proof.submit": "Kirim untuk ditinjau",
  "packages.proof.uploading": "Mengunggah…",
  "packages.proof.uploaded": "Bukti diunggah",
  "packages.proof.uploadError":
    "Tidak dapat mengunggah bukti Anda. Silakan coba lagi.",
  "packages.proof.wrongType": "Silakan pilih gambar JPG, PNG, atau WEBP.",
  "packages.proof.tooLarge":
    "Gambar itu lebih dari 5MB. Silakan pilih yang lebih kecil.",
  "packages.status.awaitingPayment": "Menunggu pembayaran",
  "packages.status.inReview": "Ditinjau",
  "packages.status.completed": "Selesai",
  "packages.status.cancelled": "Dibatalkan",
  "packages.status.expired": "Kedaluwarsa",
  "packages.purchase.title": "Pembelian Anda",
  "packages.purchase.loadingTitle": "Memuat pembelian Anda…",
  "packages.purchase.loadingSubtitle": "Ini hanya sebentar.",
  "packages.purchase.notFoundTitle": "Pembelian tidak ditemukan",
  "packages.purchase.redirectingTitle": "Mengalihkan ke pembayaran…",
  "packages.purchase.redirectingSubtitle":
    "Mengarahkan Anda ke halaman pembayaran yang aman.",
  "packages.purchase.completeTitle": "Selesaikan pembayaran Anda",
  "packages.purchase.completeSubtitle":
    "Pesanan Anda telah dipesan. Selesaikan pembayaran untuk menambah jam Anda.",
  "packages.purchase.amountToPay": "Jumlah yang harus dibayar",
  "packages.purchase.payDeadline": "Bayar sebelum",
  "packages.purchase.payLinkExpired": "Tautan pembayaran kedaluwarsa",
  "packages.purchase.payNow": "Bayar Sekarang",
  "packages.purchase.payLoading": "Membuka pembayaran…",
  "packages.purchase.payError":
    "Tidak dapat membuka pembayaran. Silakan coba lagi.",
  "packages.purchase.receptionistTitle": "Bayar di resepsionis",
  "packages.purchase.receptionistSubtitle":
    "Tunjukkan pembelian ini di resepsionis dan bayar di sana. Jam Anda akan ditambahkan setelah staf mengonfirmasi pembayaran.",
  "packages.purchase.transferTitle": "Selesaikan transfer Anda",
  "packages.purchase.transferSubtitle":
    "Transfer jumlah yang tepat, lalu unggah bukti Anda di bawah.",
  "packages.purchase.cancelReupload": "Batal",
  "packages.purchase.awaitingTitle": "Menunggu verifikasi",
  "packages.purchase.awaitingSubtitle":
    "Admin sedang meninjau transfer Anda. Kami akan menambahkan jam Anda setelah dikonfirmasi.",
  "packages.purchase.yourProof": "Bukti Anda",
  "packages.purchase.refreshStatus": "Perbarui status",
  "packages.purchase.refreshing": "Memperbarui…",
  "packages.purchase.reupload": "Unggah bukti lain",
  "packages.purchase.cancelledTitle": "Pembayaran dibatalkan",
  "packages.purchase.cancelledSubtitle":
    "Pembelian ini dibatalkan. Anda dapat memulai yang baru kapan saja.",
  "packages.purchase.tryAgain": "Coba lagi",
  "packages.purchase.expiredTitle": "Pembelian kedaluwarsa",
  "packages.purchase.expiredSubtitle":
    "Pembelian ini kedaluwarsa sebelum pembayaran. Silakan mulai lagi.",
  "packages.purchase.startOver": "Mulai lagi",
  "packages.purchase.successTitle": "Jam ditambahkan!",
  "packages.purchase.successSubtitle":
    "Jam Anda sudah siap dan keanggotaan Anda aktif.",
  "packages.purchase.packageLabel": "Paket",
  "packages.purchase.hoursCredited": "Jam Ditambahkan",
  "packages.purchase.membershipExtended": "Keanggotaan Diperpanjang",
  "packages.purchase.membershipExtendedValue": "+{days} hari",
  "packages.purchase.creditedPeak": "{count} jam peak",
  "packages.purchase.creditedOffPeak": "{count} jam off-peak",
  "packages.purchase.amountPaid": "Jumlah Dibayar",
  "packages.purchase.viewHours": "Lihat jam saya",
  "packages.purchase.backHome": "Kembali ke Beranda",
  "packages.history.title": "Riwayat pembelian",
  "packages.history.empty": "Anda belum membeli jam apa pun.",
  // Entry points
  "home.dashboard.buyHours": "Beli Jam",
  "home.dashboard.topUpHours": "Isi ulang",
  "home.card.buyMoreHours": "Beli jam lagi",
  "home.card.purchaseHistory": "Riwayat pembelian",
  "account.profile.menuPackages": "Beli Jam / Paket",
  "book.gate.buyHoursCta": "Beli jam",
  "book.gate.reactivateCta": "Beli jam untuk aktivasi",
}
